unit View.Rt_Ibs_Cbs_Cst.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math, WEBLib.StdCtrls, Web, JS, WEBLib.Lists,
  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB, XData.Web.Dataset,
  WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls, XData.Web.JsonDataset,
  Grid.Plugins, Crud.Utils, UHelperServer, System.StrUtils, UConstantes,
  WEBLib.XLSX, WEBLib.WebCtrls, System.Variants, XData.Web.Client,
  System.Generics.Collections, UUtils, UWeb.Enum,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewRt_Ibs_Cbs_CstList = class(TForm)
    btNew: TButton;
    Rt_Ibs_Cbs_CstDataset: TXDataWebDataSet;
    Rt_Ibs_Cbs_CstDatasetid: TIntegerField;
    Rt_Ibs_Cbs_CstDatasetcst: TStringField;
    Rt_Ibs_Cbs_CstDatasetdescricao: TStringField;
    Rt_Ibs_Cbs_CstDatasetexcluido: TBooleanField;
    Rt_Ibs_Cbs_CstDatasetinclusao: TDateTimeField;
    Rt_Ibs_Cbs_CstDatasetalteracao: TDateTimeField;
    Rt_Ibs_Cbs_CstDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    cbbTipoImportacao: TComboBox;
    wfpImport: TFilePicker;
    excelImport: TXLSX;
    btnImportarTabela: TButton;
    btnUpload: TButton;
    lblErro: TLabel;
    cdsIbsCbsCst: TXDataWebDataSet;
    cdsIbsCbsCstid: TIntegerField;
    cdsIbsCbsCstcst: TStringField;
    cdsIbsCbsCstdescricao: TStringField;
    cdsIbsCbsCstexcluido: TBooleanField;
    cdsIbsCbsCstinclusao: TDateTimeField;
    cdsIbsCbsCstalteracao: TDateTimeField;
    cdsIbsCbsCstexclusao: TDateTimeField;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst: TPanel;
    pnlEspacoImportacao: TPanel;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst: TPanel;
    tblImportacaoIbsCbsCst: TDBTableControl;
    pnlEspacoImportacaoClassTrib: TPanel;
    cdsClassTrib: TXDataWebDataSet;
    tblImportacaoClassTrib: TDBTableControl;
    dtsIbsCbsCst: TDataSource;
    cdsIbsCbsCstprocessado: TBooleanField;
    btnConfirmarIbsCbsCst: TButton;
    XDataClientImport: TXDataWebClient;
    dtsClassTrib: TDataSource;
    btnConfirmarClassTrib: TButton;
    cdsClassTribid: TIntegerField;
    cdsClassTribrt_ibs_cbs_cst_id: TIntegerField;
    cdsClassTribcclasstrib: TStringField;
    cdsClassTribdescricao: TStringField;
    cdsClassTriblei_complementar: TStringField;
    cdsClassTriblei_complementar_redacao: TStringField;
    cdsClassTribdata_inicio: TDateTimeField;
    cdsClassTribdata_fim: TDateTimeField;
    cdsClassTribexcluido: TBooleanField;
    cdsClassTribrt_cst_ibs_cbscst: TXDataWebDatasetField;
    cdsClassTribprocessado: TBooleanField;
    cdsClassTribrt_cst_ibs_cbs: TXDataWebEntityField;
    cdsClassTribrt_cst_ibs_cbsexcluido: TXDataWebDatasetField;
    cbbFiltroClassTrib: TComboBox;
    cbbFiltroIbsCbsCst: TComboBox;
    lblOrdemColunas: TLabel;
    cdsIbsCbsCstind_gIBSCBS: TStringField;
    cdsIbsCbsCstind_gIBSCBSMono: TStringField;
    cdsIbsCbsCstind_gRed: TStringField;
    cdsIbsCbsCstind_gDif: TStringField;
    cdsIbsCbsCstind_gTransfCred: TStringField;
    cdsClassTribnome_cClassTrib: TStringField;
    cdsClassTribtipo_aliquota: TStringField;
    cdsClassTribpRedIBS: TStringField;
    cdsClassTribpRedCBS: TStringField;
    cdsClassTribind_gTribRegular: TStringField;
    cdsClassTribdata_atualizacao: TDateField;
    cdsIbsCbsCstind_gCredPresIBSZFM: TBooleanField;
    cdsIbsCbsCstind_gAjusteCompet: TBooleanField;
    cdsIbsCbsCstexcluido_planilha: TBooleanField;
    cdsClassTribindNFe: TBooleanField;
    cdsClassTribindNFCe: TBooleanField;
    cdsClassTribindNFSe: TBooleanField;
    cdsClassTribind_gEstornoCred: TBooleanField;
    cdsClassTribind_gCredPresOper: TBooleanField;
    cdsClassTribind_gMonoPadrao: TBooleanField;
    cdsClassTribind_gMonoReten: TBooleanField;
    cdsClassTribind_gMonoRet: TBooleanField;
    cdsClassTribexcluido_planilha: TBooleanField;
    cdsIbsCbsCstind_RedutorBC: TBooleanField;
    tmrProcessarPlanilhas: TTimer;
    cdsClassTribind_gpBioDiferenca: TBooleanField;
    cdsClassTribtpRBSN: TIntegerField;
    cdsClassTribtpDoacao: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure btnImportarTabelaClick(Sender: TObject);
    procedure cbbTipoImportacaoClick(Sender: TObject);
    procedure cbbTipoImportacaoChange(Sender: TObject);
    [Async]
    procedure btnUploadClick(Sender: TObject); async;
    procedure wfpImportChange(Sender: TObject);
    procedure cdsIbsCbsCstAfterOpen(DataSet: TDataSet);
    procedure cdsClassTribAfterOpen(DataSet: TDataSet);
    procedure wfpImportGetFileAsArrayBuffer(Sender: TObject; AFileIndex: Integer; ABuffer: TJSArrayBufferRecord);
    procedure excelImportSheetLoaded(Sender: TObject; ASheetName: string);
    procedure tblImportacaoIbsCbsCstGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblImportacaoIbsCbsCstGetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
    procedure btnConfirmarIbsCbsCstClick(Sender: TObject);
    procedure XDataClientImportError(Error: TXDataClientError);
    procedure XDataClientImportLoad(Response: TXDataClientResponse);
    procedure tblImportacaoClassTribGetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
    procedure btnConfirmarClassTribClick(Sender: TObject);
    procedure tblImportacaoClassTribGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure cbbFiltroClassTribChange(Sender: TObject);
    procedure cdsClassTribFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure cbbFiltroIbsCbsCstChange(Sender: TObject);
    procedure cdsIbsCbsCstFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure WebFormShow(Sender: TObject);
    procedure excelImportWorkbookLoaded(Sender: TObject);
    procedure tmrProcessarPlanilhasTimer(Sender: TObject);
  private
    const
      FColunasClassTrib : array[0..24] of String = ('CST-IBS/CBS', 'Descrição CST-IBS/CBS', 'cClassTrib',
        'Descrição cClassTrib', 'LC 214/25', 'LC Redação', 'dIniVig', 'dFimVig', 'Nome cClassTrib',
        'Tipo de Alíquota', 'pRedIBS', 'pRedCBS', 'ind_gTribRegular', 'indNFe',
        'indNFCe', 'indNFSe', 'ind_gEstornoCred', 'ind_gCredPresOper', 'ind_gMonoPadrao',
        'ind_gMonoReten', 'ind_gMonoRet', 'ind_gpBioDiferenca', 'tpRBSN', 'tpDoacao', 'DataAtualização');
    var
      FEditProc: TEditProc;
      FGridPlugin: TGridPlugin;
      FImportacaoIbsCbsCst,
      FPodeProcessar,
      FCarregouPlanilhas: Boolean;
      FDadosCst : TDictionary<string, TJSObject>;
      FColunasNaoEncontradas,
      FAbaCst,
      FAbaClassTrib : string;
      FPersonalizacaoTabela: IPersonalizacao_Tabela;

    function ValidarDados: string;
    procedure ExportarIbsCbsCst;
    procedure ExportarClassificacaoTributaria;
    procedure GetDadosCst(pCst, pDescricao : string; var pJsValue : JSValue; var pCstId : Integer);
    procedure AtualizarClassTrib(pJson : TJSObject; pExcluido : Boolean);
    function LimparString(const pValor: string; pLimpezaCompleta : Boolean = True): string;
    procedure ControlarBotaoConfirmar(pClassTrib : Boolean);
    procedure PreencherDicionarioCbsCst;
    procedure AtualizarCst(pJson : TJSObject; pExcluido : Boolean);
    function GetJsonClassificacaoTributaria(pIndice : Integer; pColunas: TDictionary<string, Integer>) : TJSObject;
    function GetColunasClassTrib : TDictionary<string, Integer>;
    function GetCstFormatado(pCst : string) : string;
    procedure ProcessarExportacaoIbsCbsCst;


  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewRt_Ibs_Cbs_CstList: TFViewRt_Ibs_Cbs_CstList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRt_Ibs_Cbs_CstList }

procedure TFViewRt_Ibs_Cbs_CstList.btnImportarTabelaClick(Sender: TObject);
begin
  wfpImport.Files.Clear;
  lblErro.Visible := False;
  cbbTipoImportacao.ItemIndex := 0;
  wfpImport.Enabled := False;

  THelperServer.ElementoHide('OrdemColunas');
end;

procedure TFViewRt_Ibs_Cbs_CstList.btnUploadClick(Sender: TObject);
var
  lErro: string;
  lIndice: Integer;
begin
  FAbaCst := EmptyStr;
  FAbaClassTrib := EmptyStr;
  FPodeProcessar := False;
  FCarregouPlanilhas := False;

  lblErro.Visible := False;
  lErro := ValidarDados;

  if lErro <> '' then
  begin
    lblErro.Caption := lErro;
    lblErro.Visible := True;
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa importação?')) then
  begin
    tmrProcessarPlanilhas.Enabled := True;

    TUtils.ChamarDivLoading;
    TUtils.CloseModal('modal_importar_tabelas');
    FImportacaoIbsCbsCst := cbbTipoImportacao.ItemIndex = 1;
    cdsIbsCbsCst.Filtered := False;
    cdsIbsCbsCst.Close;
    cdsIbsCbsCst.Load;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.cbbFiltroClassTribChange(Sender: TObject);
begin
  cdsClassTrib.Filtered := True;
  ControlarBotaoConfirmar(True);
end;

procedure TFViewRt_Ibs_Cbs_CstList.cbbFiltroIbsCbsCstChange(Sender: TObject);
begin
  cdsIbsCbsCst.Filtered := True;
  ControlarBotaoConfirmar(False);
end;

procedure TFViewRt_Ibs_Cbs_CstList.cbbTipoImportacaoChange(Sender: TObject);
var
  lIndice : Integer;
  lOrdem : string;
begin
  wfpImport.Enabled := cbbTipoImportacao.ItemIndex <> 0;

  if wfpImport.Enabled then
  begin
    if cbbTipoImportacao.ItemIndex = 1 then
    begin
      asm
        $('#legenda_ordem_colunas').text('Ordem das colunas:');
      end;

      lblOrdemColunas.Caption := '[CST] - [Descrição CST]';
    end
    else
    begin
      asm
        $('#legenda_ordem_colunas').text('Colunas que devem existir na planilha:');
      end;

      for lIndice := Low(FColunasClassTrib) to High(FColunasClassTrib) do
      begin
        lOrdem := lOrdem + '['+FColunasClassTrib[lIndice]+'] - ';
      end;

      Delete(lOrdem, Length(lOrdem)-2, 3);
      lblOrdemColunas.Caption := lOrdem;
    end;

    THelperServer.ElementoShow('OrdemColunas');
  end
  else
    THelperServer.ElementoHide('OrdemColunas');

  wfpImport.Files.Clear;
end;

procedure TFViewRt_Ibs_Cbs_CstList.cbbTipoImportacaoClick(Sender: TObject);
begin
  lblErro.Visible := False;
end;

procedure TFViewRt_Ibs_Cbs_CstList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewRt_Ibs_Cbs_CstList.cdsClassTribAfterOpen(DataSet: TDataSet);
begin
  wfpImport.Files.Items[0].GetFileAsArrayBuffer;
end;

procedure TFViewRt_Ibs_Cbs_CstList.cdsClassTribFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
begin
  case cbbFiltroClassTrib.ItemIndex of
    0: Accept := True;
    1: Accept := (DataSet.FieldByName('rt_ibs_cbs_cst_id').AsInteger > 0) and
      ((DataSet.FieldByName('id').AsInteger <= 0) or (not DataSet.FieldByName('excluido').AsBoolean));
    2: Accept := DataSet.FieldByName('excluido').AsBoolean;
    3: Accept := DataSet.FieldByName('rt_ibs_cbs_cst_id').AsInteger <= 0;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.cdsIbsCbsCstAfterOpen(DataSet: TDataSet);
begin
  if FImportacaoIbsCbsCst then
    wfpImport.Files.Items[0].GetFileAsArrayBuffer
  else
  begin
    cdsClassTrib.Filtered := False;
    cdsClassTrib.Close;
    cdsClassTrib.Load;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.cdsIbsCbsCstFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
begin
  case cbbFiltroIbsCbsCst.ItemIndex of
    0: Accept := True;
    1: Accept := (DataSet.FieldByName('id').AsInteger <= 0) or not DataSet.FieldByName('excluido').AsBoolean;
    2: Accept := DataSet.FieldByName('excluido').AsBoolean;
  end;
end;

function TFViewRt_Ibs_Cbs_CstList.LimparString(const pValor: string; pLimpezaCompleta : Boolean = True): string;
begin
  Result := Trim(pValor);
  Result := StringReplace(Result, #$2028, ' ', [rfReplaceAll]);

  if pLimpezaCompleta then
  begin
    Result := StringReplace(Result, #$A0, ' ', [rfReplaceAll]);
    Result := StringReplace(Result, #13, '', [rfReplaceAll]);
    Result := StringReplace(Result, #10, '', [rfReplaceAll]);
    Result := StringReplace(Result, '?', '', [rfReplaceAll]);
    Result := LowerCase(Result);
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.PreencherDicionarioCbsCst;
var
  lJson: TJSObject;
  lIndice: Integer;
  lCst : string;
begin
  FDadosCst.Clear;

  for lIndice := 2 to excelImport.RowCount do
  begin
    lCst := excelImport.CellAsString[1, lIndice];

    if Trim(lCst) = '' then
      Continue
    else
      lCst := GetCstFormatado(lCst);

    lJson := TJSObject.New;
    lJson['ind_gIBSCBS'] := excelImport.CellAsString[3, lIndice];
    lJson['ind_gIBSCBSMono'] := excelImport.CellAsString[4, lIndice];
    lJson['ind_gRed'] := excelImport.CellAsString[5, lIndice];
    lJson['ind_gDif'] := excelImport.CellAsString[6, lIndice];
    lJson['ind_gTransfCred'] := excelImport.CellAsString[7, lIndice];
    lJson['ind_gCredPresIBSZFM'] := excelImport.CellAsString[8, lIndice];
    lJson['ind_gAjusteCompet'] := excelImport.CellAsString[9, lIndice];
    lJson['ind_RedutorBC'] := excelImport.CellAsString[10, lIndice];

    FDadosCst.Add(lCst, lJson);
  end;

  excelImport.ActiveSheet := FAbaClassTrib;
end;

procedure TFViewRt_Ibs_Cbs_CstList.ProcessarExportacaoIbsCbsCst;
begin
  cdsIbsCbsCst.DisableControls;

  try
    cdsIbsCbsCst.First;

    while not cdsIbsCbsCst.Eof do
    begin
      if not cdsIbsCbsCst.FieldByName('processado').AsBoolean and not cdsIbsCbsCst.FieldByName('excluido').AsBoolean then
      begin
        cdsIbsCbsCst.Edit;
        cdsIbsCbsCst.FieldByName('excluido').AsBoolean := True;
        cdsIbsCbsCst.FieldByName('processado').AsBoolean := True;
        cdsIbsCbsCst.Post;

        cdsIbsCbsCst.Next;
      end
      else if cdsIbsCbsCst.FieldByName('excluido_planilha').AsBoolean then
        cdsIbsCbsCst.Next
      else if cdsIbsCbsCst.FieldByName('excluido').AsBoolean then
        cdsIbsCbsCst.Delete
      else
        cdsIbsCbsCst.Next;
    end;
  finally
    cdsIbsCbsCst.First;
    cdsIbsCbsCst.EnableControls;
  end;

  if cdsIbsCbsCst.RecordCount = 0 then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não existem registros para serem importados!')
  else
  begin
    TUtils.OcultarDivLoading;
    cbbFiltroIbsCbsCst.ItemIndex := 0;
    ControlarBotaoConfirmar(False);
    TUtils.OpenModal('modal_importacao_ibs_cbs_cst');
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.ControlarBotaoConfirmar(pClassTrib: Boolean);
begin
  if pClassTrib then
    btnConfirmarClassTrib.Enabled := cbbFiltroClassTrib.ItemIndex <= 0
  else
    btnConfirmarIbsCbsCst.Enabled := cbbFiltroIbsCbsCst.ItemIndex <= 0;
end;

class function TFViewRt_Ibs_Cbs_CstList.CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRt_Ibs_Cbs_CstList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewRt_Ibs_Cbs_CstList, AElementID, Result, @AfterCreate);
end;

procedure TFViewRt_Ibs_Cbs_CstList.edSearchKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewRt_Ibs_Cbs_CstList.excelImportSheetLoaded(Sender: TObject; ASheetName: string);
begin
  if not FPodeProcessar then
    Exit;

  if FImportacaoIbsCbsCst then
  begin
    if ASheetName = FAbaCst then
      PreencherDicionarioCbsCst
    else
      ExportarIbsCbsCst;
  end
  else
  begin
    if ASheetName <> FAbaClassTrib then
      excelImport.ActiveSheet := FAbaClassTrib
    else
      ExportarClassificacaoTributaria;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.excelImportWorkbookLoaded(Sender: TObject);
var
  lIndice : Integer;
  lNome : string;
begin
  for lIndice := 0 to excelImport.SheetNameCount - 1 do
  begin
    lNome := excelImport.SheetNames[lIndice];

    if Pos('CST', lNome.ToUpper) > 0 then
      FAbaCst := lNome
    else if Pos('CCLASS', lNome.ToUpper) > 0 then
      FAbaClassTrib := lNome
  end;

  FCarregouPlanilhas := True;
end;

procedure TFViewRt_Ibs_Cbs_CstList.ExportarClassificacaoTributaria;
var
  lIndice,
  lCstId: Integer;
  lCClassTrib,
  lDataFormatada : string;
  lJsValue : JSValue;
  lJson : TJSObject;
  lColunas : TDictionary<string, Integer>;
  lExcluido : Boolean;
begin
  lColunas := GetColunasClassTrib;
  try
    if FColunasNaoEncontradas <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Não foi possível realizar a importação!'
        + sLineBreak + 'Colunas ' + FColunasNaoEncontradas + 'não encontradas na planilha.');

      Exit;
    end;

    for lIndice := 2 to excelImport.RowCount do
    begin
      lCClassTrib := excelImport.CellAsString[lColunas['CCLASSTRIB'], lIndice];
      lExcluido := excelImport.CellAsObject[lColunas['CCLASSTRIB'], lIndice].Font.Color = clRed;

      if Trim(lCClassTrib) = '' then
        Continue;

      lJson := GetJsonClassificacaoTributaria(lIndice, lColunas);
      lJson['CClassTrib'] := lCClassTrib;

      if cdsClassTrib.Locate('cclasstrib', lCClassTrib, [loCaseInsensitive]) then
        AtualizarClassTrib(lJson, lExcluido)
      else
      begin
        GetDadosCst(string(lJson['Cst']), string(lJson['CstDescricao']), lJsValue, lCstId);

        if (lCstId = -1) and lExcluido then
          Continue;

        cdsClassTrib.Append;
        cdsClassTrib.FieldByName('excluido_planilha').AsBoolean := False;
        cdsClassTrib.FieldByName('processado').AsBoolean := True;
        cdsClassTrib.FieldByName('id').AsInteger := 0;
        cdsClassTrib.FieldByName('rt_ibs_cbs_cst_id').AsInteger := lCstId;
        cdsClassTrib.FieldByName('rt_cst_ibs_cbs').value := lJsValue;
        cdsClassTrib.FieldByName('cclasstrib').AsString := lCClassTrib;
        cdsClassTrib.FieldByName('descricao').AsString := string(lJson['DescricaoClassTrib']);
        cdsClassTrib.FieldByName('lei_complementar').AsString := string(lJson['LeiComplementar']);
        cdsClassTrib.FieldByName('lei_complementar_redacao').AsString := string(lJson['LeiComplementarRedacao']);
        cdsClassTrib.FieldByName('excluido').AsBoolean := False;
        cdsClassTrib.FieldByName('nome_cClassTrib').AsString := string(lJson['nome_cClassTrib']);
        cdsClassTrib.FieldByName('tipo_aliquota').AsString := string(lJson['tipo_aliquota']);
        cdsClassTrib.FieldByName('pRedIBS').AsString := string(lJson['pRedIBS']);
        cdsClassTrib.FieldByName('pRedCBS').AsString := string(lJson['pRedCBS']);
        cdsClassTrib.FieldByName('ind_gTribRegular').AsString := string(lJson['ind_gTribRegular']);
        cdsClassTrib.FieldByName('indNFe').AsBoolean := THelperServer.GetBooleanValor(string(lJson['indNFe']));
        cdsClassTrib.FieldByName('indNFCe').AsBoolean := THelperServer.GetBooleanValor(string(lJson['indNFCe']));
        cdsClassTrib.FieldByName('indNFSe').AsBoolean := THelperServer.GetBooleanValor(string(lJson['indNFSe']));
        cdsClassTrib.FieldByName('ind_gEstornoCred').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gEstornoCred']));
        cdsClassTrib.FieldByName('ind_gCredPresOper').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gCredPresOper']));
        cdsClassTrib.FieldByName('ind_gMonoPadrao').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gMonoPadrao']));
        cdsClassTrib.FieldByName('ind_gMonoReten').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gMonoReten']));
        cdsClassTrib.FieldByName('ind_gMonoRet').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gMonoRet']));
        cdsClassTrib.FieldByName('ind_gpBioDiferenca').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gpBioDiferenca']));
        cdsClassTrib.FieldByName('tpRBSN').AsString := string(lJson['tpRBSN']);
        cdsClassTrib.FieldByName('tpDoacao').AsString := string(lJson['tpDoacao']);

        lDataFormatada := THelperServer.ConverterData(string(lJson['DataInicioVigencia']));

        if lDataFormatada.IsEmpty then
          cdsClassTrib.FieldByName('data_inicio').Value := Null
        else
          cdsClassTrib.FieldByName('data_inicio').AsDateTime := StrToDate(lDataFormatada);

        lDataFormatada := THelperServer.ConverterData(string(lJson['data_atualizacao']));

        if lDataFormatada.IsEmpty then
          cdsClassTrib.FieldByName('data_atualizacao').Value := Null
        else
          cdsClassTrib.FieldByName('data_atualizacao').AsDateTime := StrToDate(lDataFormatada);


        if lExcluido then
        begin
          cdsClassTrib.FieldByName('excluido').AsBoolean := True;
          cdsClassTrib.FieldByName('excluido_planilha').AsBoolean := True;
        end;

        lDataFormatada := THelperServer.ConverterData(string(lJson['DataFimVigencia']));

        if lDataFormatada.IsEmpty then
          cdsClassTrib.FieldByName('data_fim').Value := Null
        else
        begin
          cdsClassTrib.FieldByName('data_fim').AsDateTime := StrToDate(lDataFormatada);

          if StrToDate(lDataFormatada) <= Date then
            cdsClassTrib.FieldByName('excluido').AsBoolean := True;
        end;

        if cdsClassTrib.FieldByName('rt_cst_ibs_cbs.excluido').AsBoolean then
          cdsClassTrib.FieldByName('excluido').AsBoolean := True;

        cdsClassTrib.Post;
      end;
    end;

    cdsClassTrib.DisableControls;

    try
      cdsClassTrib.First;

      while not cdsClassTrib.Eof do
      begin
        if not cdsClassTrib.FieldByName('processado').AsBoolean and not cdsClassTrib.FieldByName('excluido').AsBoolean then
        begin
          cdsClassTrib.Edit;
          cdsClassTrib.FieldByName('excluido').AsBoolean := True;
          cdsClassTrib.FieldByName('processado').AsBoolean := True;
          cdsClassTrib.Post;

          cdsClassTrib.Next;
        end
        else if cdsClassTrib.FieldByName('excluido_planilha').AsBoolean then
          cdsClassTrib.Next
        else if not cdsClassTrib.FieldByName('processado').AsBoolean and cdsClassTrib.FieldByName('excluido').AsBoolean then
          cdsClassTrib.Delete
        else
          cdsClassTrib.Next;
      end;
    finally
      cdsClassTrib.First;
      cdsClassTrib.EnableControls;
    end;

    if cdsClassTrib.RecordCount = 0 then
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não existem registros para serem importados!')
    else
    begin
      TUtils.OcultarDivLoading;
      cbbFiltroClassTrib.ItemIndex := 0;
      ControlarBotaoConfirmar(True);
      TUtils.OpenModal('modal_importacao_class_trib');
    end;
  finally
    FColunasNaoEncontradas := '';

    if Assigned(lColunas) then
      FreeAndNil(lColunas);
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.ExportarIbsCbsCst;
var
  lIndice: Integer;
  lCst,
  lDescricao,
  lCstDescricao: string;
  lFieldValues: array of JSValue;
  lJson: TJSObject;
  lExcluido : Boolean;
  lVistos: TDictionary<string, Boolean>;
begin
  SetLength(lFieldValues, 2);
  lVistos := TDictionary<string, Boolean>.Create;

  try
    for lIndice := 2 to excelImport.RowCount do
    begin
      lCst := excelImport.CellAsString[1, lIndice];
      lDescricao := excelImport.CellAsString[2, lIndice];

      if Trim(lCst) = '' then
        Continue;

      lCstDescricao := lCst + ' - ' + lDescricao;

      if lVistos.ContainsKey(lCstDescricao) then
        Continue;

      lVistos.Add(lCstDescricao, True);

      lExcluido := excelImport.CellAsObject[1, lIndice].Font.Color = clRed;

      lFieldValues[0] := lCst;
      lFieldValues[1] := Trim(lDescricao);

      if FDadosCst.ContainsKey(lCst) then
        lJson := FDadosCst[lCst]
      else
        lJson := nil;

      if cdsIbsCbsCst.Locate('cst; descricao', lFieldValues, [loCaseInsensitive]) then
        AtualizarCst(lJson, lExcluido)
      else
      begin
        if lExcluido then
          Continue;

        cdsIbsCbsCst.Append;
        cdsIbsCbsCst.FieldByName('processado').AsBoolean := True;
        cdsIbsCbsCst.FieldByName('cst').AsString := lCst;
        cdsIbsCbsCst.FieldByName('descricao').AsString := lDescricao;
        cdsIbsCbsCst.FieldByName('id').AsInteger := 0;

        if lJson <> nil then
        begin
          cdsIbsCbsCst.FieldByName('ind_gIBSCBS').Value := THelperServer.GetValueOrNull(string(lJson['ind_gIBSCBS']));
          cdsIbsCbsCst.FieldByName('ind_gIBSCBSMono').Value := THelperServer.GetValueOrNull(string(lJson['ind_gIBSCBSMono']));
          cdsIbsCbsCst.FieldByName('ind_gRed').Value := THelperServer.GetValueOrNull(string(lJson['ind_gRed']));
          cdsIbsCbsCst.FieldByName('ind_gDif').Value := THelperServer.GetValueOrNull(string(lJson['ind_gDif']));
          cdsIbsCbsCst.FieldByName('ind_gTransfCred').Value := THelperServer.GetValueOrNull(string(lJson['ind_gTransfCred']));
          cdsIbsCbsCst.FieldByName('ind_gCredPresIBSZFM').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gCredPresIBSZFM']));
          cdsIbsCbsCst.FieldByName('ind_gAjusteCompet').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_gAjusteCompet']));
          cdsIbsCbsCst.FieldByName('ind_RedutorBC').AsBoolean := THelperServer.GetBooleanValor(string(lJson['ind_RedutorBC']));
        end;

        cdsIbsCbsCst.Post;
      end;
    end;

    ProcessarExportacaoIbsCbsCst;
  finally
    if Assigned(lVistos) then
      FreeAndNil(lVistos);
  end;
end;

function TFViewRt_Ibs_Cbs_CstList.GetColunasClassTrib: TDictionary<string, Integer>;
var
  lIndice,
  lIndiceAux,
  lPosicao : Integer;
begin
  FColunasNaoEncontradas := '';

  Result := TDictionary<string, Integer>.Create;

  for lIndiceAux := Low(FColunasClassTrib) to High(FColunasClassTrib) do
  begin
    lPosicao := -1;

    for lIndice := 1 to excelImport.ColumnCount do
    begin
      if excelImport.CellAsString[lIndice, 1].ToUpper = FColunasClassTrib[lIndiceAux].ToUpper then
      begin
        lPosicao := lIndice;
        Break;
      end;
    end;

    if lPosicao = -1 then
      FColunasNaoEncontradas := FColunasNaoEncontradas + FColunasClassTrib[lIndiceAux] + ', '
    else
      Result.Add(FColunasClassTrib[lIndiceAux].ToUpper, lIndice);
  end;
end;

function TFViewRt_Ibs_Cbs_CstList.GetCstFormatado(pCst: string): string;
begin
  Result := pCst;

  if Length(Result) = 1 then
    Result := '00' + pCst
  else if Length(Result) = 2 then
    Result := '0' + pCst;
end;

procedure TFViewRt_Ibs_Cbs_CstList.GetDadosCst(pCst, pDescricao: string; var pJsValue : JSValue;
  var pCstId : Integer);
var
  lFieldValues: array of JSValue;
  lJson: TJSObject;
begin
  SetLength(lFieldValues, 2);

  lFieldValues[0] := pCst;
  lFieldValues[1] := Trim(pDescricao);

  if cdsIbsCbsCst.Locate('cst; descricao', lFieldValues, [loCaseInsensitive]) then
  begin
    pCstId := cdsIbsCbsCst.FieldByName('id').AsInteger;
    pJsValue := cdsIbsCbsCst.CurrentData;
  end
  else
  begin
    pCstId := -1;

    lJson := TJSObject.New;
    lJson['id'] := 0;
    lJson['cst'] := pCst;
    lJson['descricao'] := pDescricao;

    pJsValue := JSValue(lJson);
  end;
end;

function TFViewRt_Ibs_Cbs_CstList.GetJsonClassificacaoTributaria(
  pIndice: Integer; pColunas: TDictionary<string, Integer>): TJSObject;
begin
  Result := TJSObject.New;
  Result['Cst'] := excelImport.CellAsString[pColunas['CST-IBS/CBS'], pIndice];
  Result['CstDescricao'] := excelImport.CellAsString[pColunas['DESCRIÇÃO CST-IBS/CBS'], pIndice];
  Result['DescricaoClassTrib'] := excelImport.CellAsString[pColunas['DESCRIÇÃO CCLASSTRIB'], pIndice];
  Result['LeiComplementar'] := excelImport.CellAsString[pColunas['LC 214/25'], pIndice];
  Result['DataInicioVigencia'] := excelImport.CellAsString[pColunas['DINIVIG'], pIndice];
  Result['DataFimVigencia'] := excelImport.CellAsString[pColunas['DFIMVIG'], pIndice];
  Result['LeiComplementarRedacao'] := excelImport.CellAsString[pColunas['LC REDAÇÃO'], pIndice];
  Result['nome_cClassTrib'] := excelImport.CellAsString[pColunas['NOME CCLASSTRIB'], pIndice];
  Result['tipo_aliquota'] := excelImport.CellAsString[pColunas['TIPO DE ALÍQUOTA'], pIndice];
  Result['pRedIBS'] := excelImport.CellAsString[pColunas['PREDIBS'], pIndice];
  Result['pRedCBS'] := excelImport.CellAsString[pColunas['PREDCBS'], pIndice];
  Result['ind_gTribRegular'] := excelImport.CellAsString[pColunas['IND_GTRIBREGULAR'], pIndice];
  Result['indNFe'] := excelImport.CellAsString[pColunas['INDNFE'], pIndice];
  Result['indNFCe'] := excelImport.CellAsString[pColunas['INDNFCE'], pIndice];
  Result['indNFSe'] := excelImport.CellAsString[pColunas['INDNFSE'], pIndice];
  Result['ind_gEstornoCred'] := excelImport.CellAsString[pColunas['IND_GESTORNOCRED'], pIndice];
  Result['ind_gCredPresOper'] := excelImport.CellAsString[pColunas['IND_GCREDPRESOPER'], pIndice];
  Result['ind_gMonoPadrao'] := excelImport.CellAsString[pColunas['IND_GMONOPADRAO'], pIndice];
  Result['ind_gMonoReten'] := excelImport.CellAsString[pColunas['IND_GMONORETEN'], pIndice];
  Result['ind_gMonoRet'] := excelImport.CellAsString[pColunas['IND_GMONORET'], pIndice];
  Result['ind_gpBioDiferenca'] := excelImport.CellAsString[pColunas['IND_GPBIODIFERENCA'], pIndice];
  Result['tpRBSN'] := excelImport.CellAsString[pColunas['TPRBSN'], pIndice];
  Result['tpDoacao'] := excelImport.CellAsString[pColunas['TPDOACAO'], pIndice];
  Result['data_atualizacao'] := excelImport.CellAsString[pColunas['DATAATUALIZAÇÃO'], pIndice];
end;

procedure TFViewRt_Ibs_Cbs_CstList.tblImportacaoClassTribGetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblImportacaoClassTrib.Columns[ACol].DataField, ['nome_cClassTrib']) of
      0 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.tblImportacaoClassTribGetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    if tblImportacaoClassTrib.DataSource.DataSet.FieldByName('excluido').AsBoolean then
    begin
      case IndexStr(tblImportacaoClassTrib.Columns[ACol].DataField, ['nome_cClassTrib']) of
        0: AValue := '<p class="text-danger" style="white-space:wrap; width:500px;">' + AValue + '</p>';
        else AValue := '<p class="text-danger">' + AValue + '</p>'
      end;
    end
    else if tblImportacaoClassTrib.DataSource.DataSet.FieldByName('rt_ibs_cbs_cst_id').AsInteger <= 0 then
    begin
      case IndexStr(tblImportacaoClassTrib.Columns[ACol].DataField, ['id', 'nome_cClassTrib']) of
        0:
        begin
          if AValue <> '0' then
            AValue := '<p class="text-warning">' + AValue + '</p>'
          else
            AValue := '<p class="text-warning"> - </p>';
        end;
        1: AValue := '<p class="text-warning" style="white-space:wrap; width:500px;">' + AValue + '</p>';
        else AValue := '<p class="text-warning">' + AValue + '</p>';
      end;
    end
    else if (tblImportacaoClassTrib.DataSource.DataSet.FieldByName('id').AsInteger <= 0) or
      not tblImportacaoClassTrib.DataSource.DataSet.FieldByName('excluido').AsBoolean then
    begin
      case IndexStr(tblImportacaoClassTrib.Columns[ACol].DataField, ['id', 'nome_cClassTrib']) of
        0:
        begin
          if AValue <> '0' then
            AValue := '<p class="text-success">' + AValue + '</p>'
          else
            AValue := '<p class="text-success"> - </p>';
        end;
        1: AValue := '<p class="text-success" style="white-space:wrap; width:500px;">' + AValue + '</p>';
        else AValue := '<p class="text-success">' + AValue + '</p>';
      end;
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.tblImportacaoIbsCbsCstGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if not FImportacaoIbsCbsCst then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    if tblImportacaoIbsCbsCst.Columns[ACol].Title = 'Descrição' then
      AClassName := 'text-left'
    else
      AClassName := 'text-center';
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.tblImportacaoIbsCbsCstGetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    if tblImportacaoIbsCbsCst.DataSource.DataSet.FieldByName('excluido').AsBoolean then
      AValue := '<p class="text-danger">' + AValue + '</p>'
    else if (tblImportacaoIbsCbsCst.DataSource.DataSet.FieldByName('id').AsInteger <= 0) or not tblImportacaoIbsCbsCst.DataSource.DataSet.FieldByName('excluido').AsBoolean then
    begin
      case IndexStr(tblImportacaoIbsCbsCst.Columns[ACol].DataField, ['id']) of
        0:
        begin
          if AValue <> '0' then
            AValue := '<p class="text-success">' + AValue + '</p>'
          else
            AValue := '<p class="text-success"> - </p>';
        end;
      else
        AValue := '<p class="text-success">' + AValue + '</p>';
      end;
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewRt_Ibs_Cbs_CstList.tmrProcessarPlanilhasTimer(Sender: TObject);
begin
  tmrProcessarPlanilhas.Enabled := False;

  if not FCarregouPlanilhas then
  begin
    tmrProcessarPlanilhas.Enabled := True;
    Exit;
  end
  else
  begin
    FPodeProcessar := True;

    if FImportacaoIbsCbsCst then
      excelImport.ActiveSheet := FAbaCst
    else
      excelImport.ActiveSheet := FAbaClassTrib;
  end;
end;

function TFViewRt_Ibs_Cbs_CstList.ValidarDados: string;
begin
  Result := EmptyStr;

  if Trim(cbbTipoImportacao.Text) = '' then
    Result := 'Selecione o tipo de importação!'
  else if wfpImport.Files.Count <= 0 then
    Result := 'Selecione o arquivo!'
  else if not wfpImport.Files[0].Name.ToLower.EndsWith('.xlsx') then
    Result := 'Extensão inválida! Importe o arquivo com formato .xlsx';
end;

procedure TFViewRt_Ibs_Cbs_CstList.AtualizarClassTrib(pJson : TJSObject; pExcluido : Boolean);
var
  lAtualizou : Boolean;
  lCstId : Integer;
  lJsValue : JSValue;
  lDataInicioCds,
  lDataFimCds,
  lDataAtualizacaoCds,
  lData: string;
begin
  cdsClassTrib.Edit;
  lAtualizou := False;
  GetDadosCst(string(pJson['Cst']), string(pJson['CstDescricao']), lJsValue, lCstId);

  lDataInicioCds := cdsClassTrib.FieldByName('data_inicio').AsString;
  lDataFimCds := cdsClassTrib.FieldByName('data_fim').AsString;
  lDataAtualizacaoCds := cdsClassTrib.FieldByName('data_atualizacao').AsString;
  cdsClassTrib.FieldByName('excluido_planilha').AsBoolean := False;

  if Trim(lDataInicioCds) <> '' then
    lDataInicioCds := FormatDateTime('dd/mm/yyyy', cdsClassTrib.FieldByName('data_inicio').AsDateTime);

  if Trim(lDataFimCds) <> '' then
    lDataFimCds := FormatDateTime('dd/mm/yyyy', cdsClassTrib.FieldByName('data_fim').AsDateTime);

  if Trim(lDataAtualizacaoCds) <> '' then
    lDataAtualizacaoCds := FormatDateTime('dd/mm/yyyy', cdsClassTrib.FieldByName('data_atualizacao').AsDateTime);

  if lCstId <> cdsClassTrib.FieldByName('rt_ibs_cbs_cst_id').AsInteger then
  begin
    cdsClassTrib.FieldByName('rt_ibs_cbs_cst_id').AsInteger := lCstId;
    cdsClassTrib.FieldByName('rt_cst_ibs_cbs').value := lJsValue;
    lAtualizou := True;
  end;

  if LimparString(string(pJson['DescricaoClassTrib'])) <> LimparString(cdsClassTrib.FieldByName('descricao').AsString) then
  begin
    cdsClassTrib.FieldByName('descricao').AsString := string(pJson['DescricaoClassTrib']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['LeiComplementar'])) <> LimparString(cdsClassTrib.FieldByName('lei_complementar').AsString) then
  begin
    cdsClassTrib.FieldByName('lei_complementar').AsString := string(pJson['LeiComplementar']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['LeiComplementarRedacao'])) <> LimparString(cdsClassTrib.FieldByName('lei_complementar_redacao').AsString) then
  begin
    cdsClassTrib.FieldByName('lei_complementar_redacao').AsString := string(pJson['LeiComplementarRedacao']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['nome_cClassTrib'])) <> LimparString(cdsClassTrib.FieldByName('nome_cClassTrib').AsString) then
  begin
    cdsClassTrib.FieldByName('nome_cClassTrib').AsString := string(pJson['nome_cClassTrib']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['tipo_aliquota'])) <> LimparString(cdsClassTrib.FieldByName('tipo_aliquota').AsString) then
  begin
    cdsClassTrib.FieldByName('tipo_aliquota').AsString := string(pJson['tipo_aliquota']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['pRedIBS'])) <> LimparString(cdsClassTrib.FieldByName('pRedIBS').AsString) then
  begin
    cdsClassTrib.FieldByName('pRedIBS').AsString := string(pJson['pRedIBS']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['pRedCBS'])) <> LimparString(cdsClassTrib.FieldByName('pRedCBS').AsString) then
  begin
    cdsClassTrib.FieldByName('pRedCBS').AsString := string(pJson['pRedCBS']);
    lAtualizou := True;
  end;

  if LimparString(string(pJson['ind_gTribRegular'])) <> LimparString(cdsClassTrib.FieldByName('ind_gTribRegular').AsString) then
  begin
    cdsClassTrib.FieldByName('ind_gTribRegular').AsString := string(pJson['ind_gTribRegular']);
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('indNFe').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['indNFe'])) then
  begin
    cdsClassTrib.FieldByName('indNFe').AsBoolean := THelperServer.GetBooleanValor(string(pJson['indNFe']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('indNFCe').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['indNFCe'])) then
  begin
    cdsClassTrib.FieldByName('indNFCe').AsBoolean := THelperServer.GetBooleanValor(string(pJson['indNFCe']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('indNFSe').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['indNFSe'])) then
  begin
    cdsClassTrib.FieldByName('indNFSe').AsBoolean := THelperServer.GetBooleanValor(string(pJson['indNFSe']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('ind_gEstornoCred').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gEstornoCred'])) then
  begin
    cdsClassTrib.FieldByName('ind_gEstornoCred').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gEstornoCred']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('ind_gCredPresOper').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gCredPresOper'])) then
  begin
    cdsClassTrib.FieldByName('ind_gCredPresOper').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gCredPresOper']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('ind_gMonoPadrao').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gMonoPadrao'])) then
  begin
    cdsClassTrib.FieldByName('ind_gMonoPadrao').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gMonoPadrao']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('ind_gMonoReten').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gMonoReten'])) then
  begin
    cdsClassTrib.FieldByName('ind_gMonoReten').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gMonoReten']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('ind_gMonoRet').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gMonoRet'])) then
  begin
    cdsClassTrib.FieldByName('ind_gMonoRet').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gMonoRet']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('ind_gpBioDiferenca').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gpBioDiferenca'])) then
  begin
    cdsClassTrib.FieldByName('ind_gpBioDiferenca').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gpBioDiferenca']));
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('tpRBSN').AsString <> string(pJson['tpRBSN']) then
  begin
    cdsClassTrib.FieldByName('tpRBSN').AsString := string(pJson['tpRBSN']);
    lAtualizou := True;
  end;

  if cdsClassTrib.FieldByName('tpDoacao').AsString <> string(pJson['tpDoacao']) then
  begin
    cdsClassTrib.FieldByName('tpDoacao').AsString := string(pJson['tpDoacao']);
    lAtualizou := True;
  end;

  lData := THelperServer.ConverterData(string(pJson['data_atualizacao']));

  if lData <> lDataAtualizacaoCds then
  begin
    if lData.IsEmpty then
      cdsClassTrib.FieldByName('data_atualizacao').Value := Null
    else
      cdsClassTrib.FieldByName('data_atualizacao').AsDateTime := StrToDate(lData);

    lAtualizou := True;
  end;


  lData := THelperServer.ConverterData(string(pJson['DataInicioVigencia']));
  
  if lData <> lDataInicioCds then
  begin
    if lData.IsEmpty then
      cdsClassTrib.FieldByName('data_inicio').Value := Null
    else
      cdsClassTrib.FieldByName('data_inicio').AsDateTime := StrToDate(lData);

    lAtualizou := True;
  end;


  lData := THelperServer.ConverterData(string(pJson['DataFimVigencia']));
  
  if lData <> lDataFimCds then
  begin
    if lData.IsEmpty then
      cdsClassTrib.FieldByName('data_fim').Value := Null
    else
      cdsClassTrib.FieldByName('data_fim').AsDateTime := StrToDate(lData);

    lAtualizou := True;
  end;


  if pExcluido and not cdsClassTrib.FieldByName('excluido').AsBoolean then
  begin
    cdsClassTrib.FieldByName('excluido').AsBoolean := True;
    cdsClassTrib.FieldByName('excluido_planilha').AsBoolean := True;
    cdsClassTrib.FieldByName('processado').AsBoolean := True;
    cdsClassTrib.Post;

    Exit;
  end;

  if lAtualizou then
  begin
    if (cdsClassTrib.FieldByName('data_fim').AsString = '') and not cdsClassTrib.FieldByName('rt_cst_ibs_cbs.excluido').AsBoolean then
      cdsClassTrib.FieldByName('excluido').AsBoolean := False
    else if (cdsClassTrib.FieldByName('data_fim').AsDateTime <= Date) or cdsClassTrib.FieldByName('rt_cst_ibs_cbs.excluido').AsBoolean then
      cdsClassTrib.FieldByName('excluido').AsBoolean := True
    else
      cdsClassTrib.FieldByName('excluido').AsBoolean := False;

    cdsClassTrib.FieldByName('processado').AsBoolean := True;
    cdsClassTrib.Post;
  end
  else
  begin
    if cdsClassTrib.FieldByName('rt_cst_ibs_cbs.excluido').AsBoolean and not cdsClassTrib.FieldByName('excluido').AsBoolean then
    begin
      cdsClassTrib.FieldByName('excluido').AsBoolean := True;
      lAtualizou := True;
    end
    else if (cdsClassTrib.FieldByName('data_fim').AsString <> '') and not
      cdsClassTrib.FieldByName('excluido').AsBoolean and (cdsClassTrib.FieldByName('data_fim').AsDateTime <= Date) then
    begin
      cdsClassTrib.FieldByName('excluido').AsBoolean := True;
      lAtualizou := True;
    end;

    if lAtualizou then
    begin
      cdsClassTrib.FieldByName('processado').AsBoolean := True;
      cdsClassTrib.Post;
    end
    else
      cdsClassTrib.Delete;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.AtualizarCst(pJson: TJSObject; pExcluido : Boolean);
var
  lAtualizou : Boolean;
begin
  lAtualizou := False;

  cdsIbsCbsCst.Edit;
  cdsIbsCbsCst.FieldByName('excluido_planilha').AsBoolean := False;

  if pJson <> nil then
  begin
    if cdsIbsCbsCst.FieldByName('ind_gIBSCBS').Value <> THelperServer.GetValueOrNull(string(pJson['ind_gIBSCBS'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gIBSCBS').Value := THelperServer.GetValueOrNull(string(pJson['ind_gIBSCBS']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_gIBSCBSMono').Value <> THelperServer.GetValueOrNull(string(pJson['ind_gIBSCBSMono'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gIBSCBSMono').Value := THelperServer.GetValueOrNull(string(pJson['ind_gIBSCBSMono']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_gRed').Value <> THelperServer.GetValueOrNull(string(pJson['ind_gRed'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gRed').Value := THelperServer.GetValueOrNull(string(pJson['ind_gRed']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_gDif').Value <> THelperServer.GetValueOrNull(string(pJson['ind_gDif'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gDif').Value := THelperServer.GetValueOrNull(string(pJson['ind_gDif']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_gTransfCred').Value <> THelperServer.GetValueOrNull(string(pJson['ind_gTransfCred'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gTransfCred').Value := THelperServer.GetValueOrNull(string(pJson['ind_gTransfCred']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_gCredPresIBSZFM').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gCredPresIBSZFM'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gCredPresIBSZFM').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gCredPresIBSZFM']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_gAjusteCompet').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_gAjusteCompet'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_gAjusteCompet').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_gAjusteCompet']));
      lAtualizou := True;
    end;

    if cdsIbsCbsCst.FieldByName('ind_RedutorBC').AsBoolean <> THelperServer.GetBooleanValor(string(pJson['ind_RedutorBC'])) then
    begin
      cdsIbsCbsCst.FieldByName('ind_RedutorBC').AsBoolean := THelperServer.GetBooleanValor(string(pJson['ind_RedutorBC']));
      lAtualizou := True;
    end;
  end;

  if pExcluido and not cdsIbsCbsCst.FieldByName('excluido').AsBoolean then
  begin
    cdsIbsCbsCst.FieldByName('excluido').AsBoolean := True;
    cdsIbsCbsCst.FieldByName('excluido_planilha').AsBoolean := True;
    lAtualizou := True;
  end
  else if not pExcluido then
  begin
    if cdsIbsCbsCst.FieldByName('excluido').AsBoolean then
    begin
      cdsIbsCbsCst.FieldByName('excluido').AsBoolean := False;
      lAtualizou := True;
    end;
  end;


  if lAtualizou then
  begin
    cdsIbsCbsCst.FieldByName('processado').AsBoolean := True;
    cdsIbsCbsCst.Post;
  end
  else
    cdsIbsCbsCst.Delete;
end;

procedure TFViewRt_Ibs_Cbs_CstList.btnConfirmarClassTribClick(Sender: TObject);
var
  lArray: TJSArray;
  lJsObject: TJSObject;
  lConfirmar : Boolean;
begin
  if cdsClassTrib.Locate('rt_ibs_cbs_cst_id', -1, [loCaseInsensitive]) then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'A importação não pode ser executada pois ' +
      'existe(m) registro(s) em que o CST não foi cadastrado no banco!' + sLineBreak +
      'Faça a importação do CST para continuar.');

    Exit;
  end;


  TUtils.ChamarDivLoading;
  cdsClassTrib.DisableControls;

  lArray := TJSArray.new;

  try
    cdsClassTrib.First;

    while not cdsClassTrib.Eof do
    begin
      lJsObject := TJSObject(cdsClassTrib.CurrentData);
      lArray.push(lJsObject);

      cdsClassTrib.Next;
    end;
  finally
    cdsClassTrib.First;

    cdsClassTrib.EnableControls;
  end;

  XDataClientImport.RawInvoke('ISinc_Servidor_Retaguarda_Service.ImportarIbsCbs', ['CLASS_TRIB', wfpImport.Files[0].Name, lArray]);
end;

procedure TFViewRt_Ibs_Cbs_CstList.btnConfirmarIbsCbsCstClick(Sender: TObject);
var
  lArray: TJSArray;
  lJsObject: TJSObject;
begin
  TUtils.ChamarDivLoading;
  cdsIbsCbsCst.DisableControls;

  lArray := TJSArray.new;

  try
    cdsIbsCbsCst.First;

    while not cdsIbsCbsCst.Eof do
    begin
      lJsObject := TJSObject(cdsIbsCbsCst.CurrentData);
      lArray.push(lJsObject);

      cdsIbsCbsCst.Next;
    end;
  finally
    cdsIbsCbsCst.First;

    cdsIbsCbsCst.EnableControls;
  end;

  XDataClientImport.RawInvoke('ISinc_Servidor_Retaguarda_Service.ImportarIbsCbs', ['IBS_CBS_CST', wfpImport.Files[0].Name, lArray]);
end;

procedure TFViewRt_Ibs_Cbs_CstList.btNewClick(Sender: TObject);
begin
  FEditProc(nil);
end;

procedure TFViewRt_Ibs_Cbs_CstList.WebDBTableControl1GetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(Rt_Ibs_Cbs_CstDataset.Connection.Model.DefaultSchema.FindEntityType(Rt_Ibs_Cbs_CstDataset.EntitySetName), Rt_Ibs_Cbs_CstDataset.CurrentData);

    Button := TButton.Create(nil);

    if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
      Button.Caption := '<i class="fa fa-edit"></i>'
    else
      Button.Caption := '<i class="fa fa-eye"></i>';

    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_rt_ibs_cbs_cst');
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.WebDBTableControl1GetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['descricao']) of
      0:
        AClassName := 'text-left';
    else
      AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.WebDBTableControl1GetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'descricao']) of
      0:
        begin
          if AValue = 'True' then
            AValue := '<i class="fas fa-check text-success"><i>'
          else if AValue = 'False' then
            AValue := '<i class="fas fa-times text-danger"><i>'
        end;
      1:
        begin
          if Length(AValue) > 100 then
            AValue := Copy(AValue, 1, 100) + '...';
        end;
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstList.WebFormCloseQuery(Sender: TObject;
  var CanClose: Boolean);
begin
  if CanClose and Assigned(FDadosCst) then
    FreeAndNil(FDadosCst);
end;

procedure TFViewRt_Ibs_Cbs_CstList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('rt_ibs_cbs_cst', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetValorDicionarioClasses('reforma_tributaria_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_reforma_tributaria', 'active');

  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Rt_Ibs_Cbs_CstDataset, lcPaginator, lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
  FDadosCst := TDictionary<string, TJSObject>.Create;
end;

procedure TFViewRt_Ibs_Cbs_CstList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Rt_Ibs_Cbs_CstDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
  begin
    btNew.Enabled := False;
    TUtils.ControlarSelect('cbbTipoImportacao', '1 - IBS CBS CST', True);
  end;

  if not TUtils.PossuiPermissao('rt_ibs_cbs_class_tributaria', TTipoPermissao.INSERIR) then
    TUtils.ControlarSelect('cbbTipoImportacao', '2 - IBS CBS CLASS TRIBUTARIA', True);
end;

procedure TFViewRt_Ibs_Cbs_CstList.wfpImportChange(Sender: TObject);
begin
  lblErro.Visible := False;
end;

procedure TFViewRt_Ibs_Cbs_CstList.wfpImportGetFileAsArrayBuffer(Sender: TObject; AFileIndex: Integer; ABuffer: TJSArrayBufferRecord);
begin
  excelImport.Load(ABuffer);
end;

procedure TFViewRt_Ibs_Cbs_CstList.XDataClientImportError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewRt_Ibs_Cbs_CstList.XDataClientImportLoad(Response: TXDataClientResponse);
begin
  if FImportacaoIbsCbsCst then
    TUtils.CloseModal('modal_importacao_ibs_cbs_cst')
  else
    TUtils.CloseModal('modal_importacao_class_trib');

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Dados importados com sucesso!');
  FGridPlugin.Load;
end;

procedure TFViewRt_Ibs_Cbs_CstList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.rt_ibs_cbs_cst.list.pagination.info');
  lblErro := TLabel.Create('lblErro');
  lblOrdemColunas := TLabel.Create('lblOrdemColunas');
  btNew := TButton.Create('view.rt_ibs_cbs_cst.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.rt_ibs_cbs_cst.list.table');
  cbPageSize := TComboBox.Create('view.rt_ibs_cbs_cst.list.cbPageSize');
  edSearch := TEdit.Create('view.rt_ibs_cbs_cst.list.search');
  lcPaginator := TListControl.Create('view.rt_ibs_cbs_cst.list.pagination');
  cbbTipoImportacao := TComboBox.Create('cbbTipoImportacao');
  wfpImport := TFilePicker.Create('wfpImport');
  btnImportarTabela := TButton.Create('btnImportarTabela');
  btnUpload := TButton.Create('btnUpload');
  pnlEspacoTabelaRt_Ibs_Cbs_Cst := TPanel.Create(Self);
  pnlEspacoImportacao := TPanel.Create(Self);
  pnlEspacoImportacaoRt_Ibs_Cbs_Cst := TPanel.Create(Self);
  tblImportacaoIbsCbsCst := TDBTableControl.Create('tblImportacaoIbsCbsCst');
  pnlEspacoImportacaoClassTrib := TPanel.Create(Self);
  tblImportacaoClassTrib := TDBTableControl.Create('tblImportacaoClassTrib');
  btnConfirmarIbsCbsCst := TButton.Create('btnConfirmarIbsCbsCst');
  btnConfirmarClassTrib := TButton.Create('btnConfirmarClassTrib');
  cbbFiltroClassTrib := TComboBox.Create('cbbFiltroClassTrib');
  cbbFiltroIbsCbsCst := TComboBox.Create('cbbFiltroIbsCbsCst');
  Rt_Ibs_Cbs_CstDataset := TXDataWebDataSet.Create(Self);
  Rt_Ibs_Cbs_CstDatasetid := TIntegerField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetcst := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetdescricao := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetexcluido := TBooleanField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetinclusao := TDateTimeField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetalteracao := TDateTimeField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  excelImport := TXLSX.Create(Self);
  cdsIbsCbsCst := TXDataWebDataSet.Create(Self);
  cdsIbsCbsCstid := TIntegerField.Create(Self);
  cdsIbsCbsCstcst := TStringField.Create(Self);
  cdsIbsCbsCstdescricao := TStringField.Create(Self);
  cdsIbsCbsCstexcluido := TBooleanField.Create(Self);
  cdsIbsCbsCstinclusao := TDateTimeField.Create(Self);
  cdsIbsCbsCstalteracao := TDateTimeField.Create(Self);
  cdsIbsCbsCstexclusao := TDateTimeField.Create(Self);
  cdsIbsCbsCstprocessado := TBooleanField.Create(Self);
  cdsIbsCbsCstind_gIBSCBS := TStringField.Create(Self);
  cdsIbsCbsCstind_gIBSCBSMono := TStringField.Create(Self);
  cdsIbsCbsCstind_gRed := TStringField.Create(Self);
  cdsIbsCbsCstind_gDif := TStringField.Create(Self);
  cdsIbsCbsCstind_gTransfCred := TStringField.Create(Self);
  cdsIbsCbsCstind_gCredPresIBSZFM := TBooleanField.Create(Self);
  cdsIbsCbsCstind_gAjusteCompet := TBooleanField.Create(Self);
  cdsIbsCbsCstexcluido_planilha := TBooleanField.Create(Self);
  cdsIbsCbsCstind_RedutorBC := TBooleanField.Create(Self);
  cdsClassTrib := TXDataWebDataSet.Create(Self);
  cdsClassTribid := TIntegerField.Create(Self);
  cdsClassTribrt_ibs_cbs_cst_id := TIntegerField.Create(Self);
  cdsClassTribcclasstrib := TStringField.Create(Self);
  cdsClassTribdescricao := TStringField.Create(Self);
  cdsClassTriblei_complementar := TStringField.Create(Self);
  cdsClassTriblei_complementar_redacao := TStringField.Create(Self);
  cdsClassTribdata_inicio := TDateTimeField.Create(Self);
  cdsClassTribdata_fim := TDateTimeField.Create(Self);
  cdsClassTribexcluido := TBooleanField.Create(Self);
  cdsClassTribrt_cst_ibs_cbscst := TXDataWebDatasetField.Create(Self);
  cdsClassTribprocessado := TBooleanField.Create(Self);
  cdsClassTribrt_cst_ibs_cbs := TXDataWebEntityField.Create(Self);
  cdsClassTribrt_cst_ibs_cbsexcluido := TXDataWebDatasetField.Create(Self);
  cdsClassTribnome_cClassTrib := TStringField.Create(Self);
  cdsClassTribtipo_aliquota := TStringField.Create(Self);
  cdsClassTribpRedIBS := TStringField.Create(Self);
  cdsClassTribpRedCBS := TStringField.Create(Self);
  cdsClassTribind_gTribRegular := TStringField.Create(Self);
  cdsClassTribdata_atualizacao := TDateField.Create(Self);
  cdsClassTribindNFe := TBooleanField.Create(Self);
  cdsClassTribindNFCe := TBooleanField.Create(Self);
  cdsClassTribindNFSe := TBooleanField.Create(Self);
  cdsClassTribind_gEstornoCred := TBooleanField.Create(Self);
  cdsClassTribind_gCredPresOper := TBooleanField.Create(Self);
  cdsClassTribind_gMonoPadrao := TBooleanField.Create(Self);
  cdsClassTribind_gMonoReten := TBooleanField.Create(Self);
  cdsClassTribind_gMonoRet := TBooleanField.Create(Self);
  cdsClassTribexcluido_planilha := TBooleanField.Create(Self);
  cdsClassTribind_gpBioDiferenca := TBooleanField.Create(Self);
  cdsClassTribtpRBSN := TIntegerField.Create(Self);
  cdsClassTribtpDoacao := TIntegerField.Create(Self);
  dtsIbsCbsCst := TDataSource.Create(Self);
  XDataClientImport := TXDataWebClient.Create(Self);
  dtsClassTrib := TDataSource.Create(Self);
  tmrProcessarPlanilhas := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  lblErro.BeforeLoadDFMValues;
  lblOrdemColunas.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  cbbTipoImportacao.BeforeLoadDFMValues;
  wfpImport.BeforeLoadDFMValues;
  btnImportarTabela.BeforeLoadDFMValues;
  btnUpload.BeforeLoadDFMValues;
  pnlEspacoTabelaRt_Ibs_Cbs_Cst.BeforeLoadDFMValues;
  pnlEspacoImportacao.BeforeLoadDFMValues;
  pnlEspacoImportacaoRt_Ibs_Cbs_Cst.BeforeLoadDFMValues;
  tblImportacaoIbsCbsCst.BeforeLoadDFMValues;
  pnlEspacoImportacaoClassTrib.BeforeLoadDFMValues;
  tblImportacaoClassTrib.BeforeLoadDFMValues;
  btnConfirmarIbsCbsCst.BeforeLoadDFMValues;
  btnConfirmarClassTrib.BeforeLoadDFMValues;
  cbbFiltroClassTrib.BeforeLoadDFMValues;
  cbbFiltroIbsCbsCst.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDataset.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetid.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetcst.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetdescricao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetexcluido.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetinclusao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetalteracao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  excelImport.BeforeLoadDFMValues;
  cdsIbsCbsCst.BeforeLoadDFMValues;
  cdsIbsCbsCstid.BeforeLoadDFMValues;
  cdsIbsCbsCstcst.BeforeLoadDFMValues;
  cdsIbsCbsCstdescricao.BeforeLoadDFMValues;
  cdsIbsCbsCstexcluido.BeforeLoadDFMValues;
  cdsIbsCbsCstinclusao.BeforeLoadDFMValues;
  cdsIbsCbsCstalteracao.BeforeLoadDFMValues;
  cdsIbsCbsCstexclusao.BeforeLoadDFMValues;
  cdsIbsCbsCstprocessado.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gIBSCBS.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gIBSCBSMono.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gRed.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gDif.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gTransfCred.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gCredPresIBSZFM.BeforeLoadDFMValues;
  cdsIbsCbsCstind_gAjusteCompet.BeforeLoadDFMValues;
  cdsIbsCbsCstexcluido_planilha.BeforeLoadDFMValues;
  cdsIbsCbsCstind_RedutorBC.BeforeLoadDFMValues;
  cdsClassTrib.BeforeLoadDFMValues;
  cdsClassTribid.BeforeLoadDFMValues;
  cdsClassTribrt_ibs_cbs_cst_id.BeforeLoadDFMValues;
  cdsClassTribcclasstrib.BeforeLoadDFMValues;
  cdsClassTribdescricao.BeforeLoadDFMValues;
  cdsClassTriblei_complementar.BeforeLoadDFMValues;
  cdsClassTriblei_complementar_redacao.BeforeLoadDFMValues;
  cdsClassTribdata_inicio.BeforeLoadDFMValues;
  cdsClassTribdata_fim.BeforeLoadDFMValues;
  cdsClassTribexcluido.BeforeLoadDFMValues;
  cdsClassTribrt_cst_ibs_cbscst.BeforeLoadDFMValues;
  cdsClassTribprocessado.BeforeLoadDFMValues;
  cdsClassTribrt_cst_ibs_cbs.BeforeLoadDFMValues;
  cdsClassTribrt_cst_ibs_cbsexcluido.BeforeLoadDFMValues;
  cdsClassTribnome_cClassTrib.BeforeLoadDFMValues;
  cdsClassTribtipo_aliquota.BeforeLoadDFMValues;
  cdsClassTribpRedIBS.BeforeLoadDFMValues;
  cdsClassTribpRedCBS.BeforeLoadDFMValues;
  cdsClassTribind_gTribRegular.BeforeLoadDFMValues;
  cdsClassTribdata_atualizacao.BeforeLoadDFMValues;
  cdsClassTribindNFe.BeforeLoadDFMValues;
  cdsClassTribindNFCe.BeforeLoadDFMValues;
  cdsClassTribindNFSe.BeforeLoadDFMValues;
  cdsClassTribind_gEstornoCred.BeforeLoadDFMValues;
  cdsClassTribind_gCredPresOper.BeforeLoadDFMValues;
  cdsClassTribind_gMonoPadrao.BeforeLoadDFMValues;
  cdsClassTribind_gMonoReten.BeforeLoadDFMValues;
  cdsClassTribind_gMonoRet.BeforeLoadDFMValues;
  cdsClassTribexcluido_planilha.BeforeLoadDFMValues;
  cdsClassTribind_gpBioDiferenca.BeforeLoadDFMValues;
  cdsClassTribtpRBSN.BeforeLoadDFMValues;
  cdsClassTribtpDoacao.BeforeLoadDFMValues;
  dtsIbsCbsCst.BeforeLoadDFMValues;
  XDataClientImport.BeforeLoadDFMValues;
  dtsClassTrib.BeforeLoadDFMValues;
  tmrProcessarPlanilhas.BeforeLoadDFMValues;
  try
    Name := 'FViewRt_Ibs_Cbs_CstList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCloseQuery', 'WebFormCloseQuery');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 344;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    lblErro.SetParentComponent(Self);
    lblErro.Name := 'lblErro';
    lblErro.Left := 8;
    lblErro.Top := 461;
    lblErro.Width := 24;
    lblErro.Height := 13;
    lblErro.Caption := 'Erro:';
    lblErro.HeightPercent := 100.000000000000000000;
    lblErro.Visible := False;
    lblErro.WidthPercent := 100.000000000000000000;
    lblOrdemColunas.SetParentComponent(Self);
    lblOrdemColunas.Name := 'lblOrdemColunas';
    lblOrdemColunas.Left := 8;
    lblOrdemColunas.Top := 479;
    lblOrdemColunas.Width := 80;
    lblOrdemColunas.Height := 13;
    lblOrdemColunas.Caption := 'lblOrdemColunas';
    lblOrdemColunas.HeightPercent := 100.000000000000000000;
    lblOrdemColunas.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 112;
    btNew.Top := 31;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 62;
    WebDBTableControl1.Width := 297;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst';
      Title := 'cst';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 35;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 184;
    edSearch.Top := 35;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 184;
    lcPaginator.Top := 333;
    lcPaginator.Width := 121;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    cbbTipoImportacao.SetParentComponent(Self);
    cbbTipoImportacao.Name := 'cbbTipoImportacao';
    cbbTipoImportacao.Left := 160;
    cbbTipoImportacao.Top := 399;
    cbbTipoImportacao.Width := 145;
    cbbTipoImportacao.Height := 21;
    cbbTipoImportacao.HeightPercent := 100.000000000000000000;
    cbbTipoImportacao.WidthPercent := 100.000000000000000000;
    SetEvent(cbbTipoImportacao, Self, 'OnChange', 'cbbTipoImportacaoChange');
    SetEvent(cbbTipoImportacao, Self, 'OnClick', 'cbbTipoImportacaoClick');
    cbbTipoImportacao.ItemIndex := 0;
    cbbTipoImportacao.Items.BeginUpdate;
    try
      cbbTipoImportacao.Items.Clear;
      cbbTipoImportacao.Items.Add('');
      cbbTipoImportacao.Items.Add('1 - IBS CBS CST');
      cbbTipoImportacao.Items.Add('2 - IBS CBS CLASS TRIBUTARIA');
    finally
      cbbTipoImportacao.Items.EndUpdate;
    end;
    wfpImport.SetParentComponent(Self);
    wfpImport.Name := 'wfpImport';
    wfpImport.Left := 160;
    wfpImport.Top := 436;
    wfpImport.Width := 145;
    wfpImport.Height := 19;
    wfpImport.Accept := '.xlsx';
    wfpImport.ChildOrder := 1;
    SetEvent(wfpImport, Self, 'OnChange', 'wfpImportChange');
    SetEvent(wfpImport, Self, 'OnGetFileAsArrayBuffer', 'wfpImportGetFileAsArrayBuffer');
    btnImportarTabela.SetParentComponent(Self);
    btnImportarTabela.Name := 'btnImportarTabela';
    btnImportarTabela.Left := 8;
    btnImportarTabela.Top := 399;
    btnImportarTabela.Width := 96;
    btnImportarTabela.Height := 25;
    btnImportarTabela.Caption := 'Importar Tabela';
    btnImportarTabela.ChildOrder := 24;
    btnImportarTabela.HeightPercent := 100.000000000000000000;
    btnImportarTabela.TabStop := False;
    btnImportarTabela.WidthPercent := 100.000000000000000000;
    SetEvent(btnImportarTabela, Self, 'OnClick', 'btnImportarTabelaClick');
    btnUpload.SetParentComponent(Self);
    btnUpload.Name := 'btnUpload';
    btnUpload.Left := 8;
    btnUpload.Top := 430;
    btnUpload.Width := 96;
    btnUpload.Height := 25;
    btnUpload.Caption := 'Importar';
    btnUpload.ChildOrder := 24;
    btnUpload.HeightPercent := 100.000000000000000000;
    btnUpload.WidthPercent := 100.000000000000000000;
    SetEvent(btnUpload, Self, 'OnClick', 'btnUploadClick');
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.SetParentComponent(Self);
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Name := 'pnlEspacoTabelaRt_Ibs_Cbs_Cst';
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Left := 0;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Top := 8;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Width := 305;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Height := 17;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Caption := 'Espa'#231'o Tabela Rt Ibs Cbs Cst';
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.ChildOrder := 23;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Color := clInfoText;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Font.Color := clWhite;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Font.Height := -11;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Font.Name := 'Tahoma';
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Font.Style := [fsBold];
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.ParentFont := False;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.TabOrder := 9;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.Visible := False;
    pnlEspacoImportacao.SetParentComponent(Self);
    pnlEspacoImportacao.Name := 'pnlEspacoImportacao';
    pnlEspacoImportacao.Left := 8;
    pnlEspacoImportacao.Top := 376;
    pnlEspacoImportacao.Width := 297;
    pnlEspacoImportacao.Height := 17;
    pnlEspacoImportacao.Caption := 'Espa'#231'o Importa'#231#227'o';
    pnlEspacoImportacao.ChildOrder := 23;
    pnlEspacoImportacao.Color := clInfoText;
    pnlEspacoImportacao.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoImportacao.Font.Color := clWhite;
    pnlEspacoImportacao.Font.Height := -11;
    pnlEspacoImportacao.Font.Name := 'Tahoma';
    pnlEspacoImportacao.Font.Style := [fsBold];
    pnlEspacoImportacao.ParentFont := False;
    pnlEspacoImportacao.TabOrder := 10;
    pnlEspacoImportacao.Visible := False;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.SetParentComponent(Self);
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Name := 'pnlEspacoImportacaoRt_Ibs_Cbs_Cst';
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Left := 352;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Top := 8;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Width := 305;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Height := 17;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Caption := 'Espa'#231'o Importa'#231#227'o Rt Ibs Cbs Cst';
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.ChildOrder := 23;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Color := clInfoText;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Font.Color := clWhite;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Font.Height := -11;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Font.Name := 'Tahoma';
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Font.Style := [fsBold];
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.ParentFont := False;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.TabOrder := 11;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.Visible := False;
    tblImportacaoIbsCbsCst.SetParentComponent(Self);
    tblImportacaoIbsCbsCst.Name := 'tblImportacaoIbsCbsCst';
    tblImportacaoIbsCbsCst.Left := 360;
    tblImportacaoIbsCbsCst.Top := 31;
    tblImportacaoIbsCbsCst.Width := 297;
    tblImportacaoIbsCbsCst.Height := 162;
    tblImportacaoIbsCbsCst.ElementClassName := 'table-responsive';
    tblImportacaoIbsCbsCst.BorderColor := clSilver;
    tblImportacaoIbsCbsCst.ChildOrder := 14;
    tblImportacaoIbsCbsCst.ColHeader := False;
    tblImportacaoIbsCbsCst.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblImportacaoIbsCbsCst, Self, 'OnGetCellData', 'tblImportacaoIbsCbsCstGetCellData');
    SetEvent(tblImportacaoIbsCbsCst, Self, 'OnGetCellClass', 'tblImportacaoIbsCbsCstGetCellClass');
    tblImportacaoIbsCbsCst.Columns.Clear;
    with tblImportacaoIbsCbsCst.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblImportacaoIbsCbsCst.Columns.Add do
    begin
      DataField := 'cst';
      Title := 'cst';
    end;
    with tblImportacaoIbsCbsCst.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    tblImportacaoIbsCbsCst.DataSource := dtsIbsCbsCst;
    pnlEspacoImportacaoClassTrib.SetParentComponent(Self);
    pnlEspacoImportacaoClassTrib.Name := 'pnlEspacoImportacaoClassTrib';
    pnlEspacoImportacaoClassTrib.Left := 360;
    pnlEspacoImportacaoClassTrib.Top := 248;
    pnlEspacoImportacaoClassTrib.Width := 305;
    pnlEspacoImportacaoClassTrib.Height := 17;
    pnlEspacoImportacaoClassTrib.Caption := 'Espa'#231'o Importa'#231#227'o Class Trib';
    pnlEspacoImportacaoClassTrib.ChildOrder := 23;
    pnlEspacoImportacaoClassTrib.Color := clInfoText;
    pnlEspacoImportacaoClassTrib.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoImportacaoClassTrib.Font.Color := clWhite;
    pnlEspacoImportacaoClassTrib.Font.Height := -11;
    pnlEspacoImportacaoClassTrib.Font.Name := 'Tahoma';
    pnlEspacoImportacaoClassTrib.Font.Style := [fsBold];
    pnlEspacoImportacaoClassTrib.ParentFont := False;
    pnlEspacoImportacaoClassTrib.TabOrder := 13;
    pnlEspacoImportacaoClassTrib.Visible := False;
    tblImportacaoClassTrib.SetParentComponent(Self);
    tblImportacaoClassTrib.Name := 'tblImportacaoClassTrib';
    tblImportacaoClassTrib.Left := 368;
    tblImportacaoClassTrib.Top := 271;
    tblImportacaoClassTrib.Width := 297;
    tblImportacaoClassTrib.Height := 162;
    tblImportacaoClassTrib.ElementClassName := 'table-responsive';
    tblImportacaoClassTrib.BorderColor := clSilver;
    tblImportacaoClassTrib.ChildOrder := 14;
    tblImportacaoClassTrib.ColHeader := False;
    tblImportacaoClassTrib.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblImportacaoClassTrib, Self, 'OnGetCellData', 'tblImportacaoClassTribGetCellData');
    SetEvent(tblImportacaoClassTrib, Self, 'OnGetCellClass', 'tblImportacaoClassTribGetCellClass');
    tblImportacaoClassTrib.Columns.Clear;
    with tblImportacaoClassTrib.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblImportacaoClassTrib.Columns.Add do
    begin
      DataField := 'rt_cst_ibs_cbs.cst';
      Title := 'cst';
    end;
    with tblImportacaoClassTrib.Columns.Add do
    begin
      DataField := 'cclasstrib';
      Title := 'CClassTrib';
    end;
    with tblImportacaoClassTrib.Columns.Add do
    begin
      DataField := 'nome_cClassTrib';
      Title := 'nome cClassTrib';
    end;
    with tblImportacaoClassTrib.Columns.Add do
    begin
      DataField := 'data_inicio';
      Title := 'Data In'#237'cio';
    end;
    with tblImportacaoClassTrib.Columns.Add do
    begin
      DataField := 'data_fim';
      Title := 'Data Fim';
    end;
    tblImportacaoClassTrib.DataSource := dtsClassTrib;
    btnConfirmarIbsCbsCst.SetParentComponent(Self);
    btnConfirmarIbsCbsCst.Name := 'btnConfirmarIbsCbsCst';
    btnConfirmarIbsCbsCst.Left := 360;
    btnConfirmarIbsCbsCst.Top := 199;
    btnConfirmarIbsCbsCst.Width := 96;
    btnConfirmarIbsCbsCst.Height := 25;
    btnConfirmarIbsCbsCst.Caption := 'Confirmar';
    btnConfirmarIbsCbsCst.ChildOrder := 24;
    btnConfirmarIbsCbsCst.HeightPercent := 100.000000000000000000;
    btnConfirmarIbsCbsCst.WidthPercent := 100.000000000000000000;
    SetEvent(btnConfirmarIbsCbsCst, Self, 'OnClick', 'btnConfirmarIbsCbsCstClick');
    btnConfirmarClassTrib.SetParentComponent(Self);
    btnConfirmarClassTrib.Name := 'btnConfirmarClassTrib';
    btnConfirmarClassTrib.Left := 360;
    btnConfirmarClassTrib.Top := 456;
    btnConfirmarClassTrib.Width := 96;
    btnConfirmarClassTrib.Height := 25;
    btnConfirmarClassTrib.Caption := 'Confirmar';
    btnConfirmarClassTrib.ChildOrder := 24;
    btnConfirmarClassTrib.HeightPercent := 100.000000000000000000;
    btnConfirmarClassTrib.WidthPercent := 100.000000000000000000;
    SetEvent(btnConfirmarClassTrib, Self, 'OnClick', 'btnConfirmarClassTribClick');
    cbbFiltroClassTrib.SetParentComponent(Self);
    cbbFiltroClassTrib.Name := 'cbbFiltroClassTrib';
    cbbFiltroClassTrib.Left := 512;
    cbbFiltroClassTrib.Top := 453;
    cbbFiltroClassTrib.Width := 145;
    cbbFiltroClassTrib.Height := 21;
    cbbFiltroClassTrib.HeightPercent := 100.000000000000000000;
    cbbFiltroClassTrib.Text := 'Todos';
    cbbFiltroClassTrib.WidthPercent := 100.000000000000000000;
    SetEvent(cbbFiltroClassTrib, Self, 'OnChange', 'cbbFiltroClassTribChange');
    cbbFiltroClassTrib.ItemIndex := 0;
    cbbFiltroClassTrib.Items.BeginUpdate;
    try
      cbbFiltroClassTrib.Items.Clear;
      cbbFiltroClassTrib.Items.Add('Todos');
      cbbFiltroClassTrib.Items.Add('Inseridos/Atualizados');
      cbbFiltroClassTrib.Items.Add('Exclu'#237'dos');
      cbbFiltroClassTrib.Items.Add('Cst n'#227'o cadastrado');
    finally
      cbbFiltroClassTrib.Items.EndUpdate;
    end;
    cbbFiltroIbsCbsCst.SetParentComponent(Self);
    cbbFiltroIbsCbsCst.Name := 'cbbFiltroIbsCbsCst';
    cbbFiltroIbsCbsCst.Left := 488;
    cbbFiltroIbsCbsCst.Top := 199;
    cbbFiltroIbsCbsCst.Width := 145;
    cbbFiltroIbsCbsCst.Height := 21;
    cbbFiltroIbsCbsCst.HeightPercent := 100.000000000000000000;
    cbbFiltroIbsCbsCst.Text := 'Todos';
    cbbFiltroIbsCbsCst.WidthPercent := 100.000000000000000000;
    SetEvent(cbbFiltroIbsCbsCst, Self, 'OnChange', 'cbbFiltroIbsCbsCstChange');
    cbbFiltroIbsCbsCst.ItemIndex := 0;
    cbbFiltroIbsCbsCst.Items.BeginUpdate;
    try
      cbbFiltroIbsCbsCst.Items.Clear;
      cbbFiltroIbsCbsCst.Items.Add('Todos');
      cbbFiltroIbsCbsCst.Items.Add('Inseridos/Atualizados');
      cbbFiltroIbsCbsCst.Items.Add('Exclu'#237'dos');
    finally
      cbbFiltroIbsCbsCst.Items.EndUpdate;
    end;
    Rt_Ibs_Cbs_CstDataset.SetParentComponent(Self);
    Rt_Ibs_Cbs_CstDataset.Name := 'Rt_Ibs_Cbs_CstDataset';
    Rt_Ibs_Cbs_CstDataset.EntitySetName := 'Rt_Ibs_Cbs_Cst';
    Rt_Ibs_Cbs_CstDataset.Connection := DMConnection.ApiConnection;
    Rt_Ibs_Cbs_CstDataset.Left := 72;
    Rt_Ibs_Cbs_CstDataset.Top := 112;
    Rt_Ibs_Cbs_CstDatasetid.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetid.Name := 'Rt_Ibs_Cbs_CstDatasetid';
    Rt_Ibs_Cbs_CstDatasetid.FieldName := 'id';
    Rt_Ibs_Cbs_CstDatasetid.Required := True;
    Rt_Ibs_Cbs_CstDatasetcst.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetcst.Name := 'Rt_Ibs_Cbs_CstDatasetcst';
    Rt_Ibs_Cbs_CstDatasetcst.FieldName := 'cst';
    Rt_Ibs_Cbs_CstDatasetcst.Required := True;
    Rt_Ibs_Cbs_CstDatasetcst.Size := 255;
    Rt_Ibs_Cbs_CstDatasetdescricao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetdescricao.Name := 'Rt_Ibs_Cbs_CstDatasetdescricao';
    Rt_Ibs_Cbs_CstDatasetdescricao.FieldName := 'descricao';
    Rt_Ibs_Cbs_CstDatasetdescricao.Required := True;
    Rt_Ibs_Cbs_CstDatasetdescricao.Size := 255;
    Rt_Ibs_Cbs_CstDatasetexcluido.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetexcluido.Name := 'Rt_Ibs_Cbs_CstDatasetexcluido';
    Rt_Ibs_Cbs_CstDatasetexcluido.FieldName := 'excluido';
    Rt_Ibs_Cbs_CstDatasetinclusao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetinclusao.Name := 'Rt_Ibs_Cbs_CstDatasetinclusao';
    Rt_Ibs_Cbs_CstDatasetinclusao.FieldName := 'inclusao';
    Rt_Ibs_Cbs_CstDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Ibs_Cbs_CstDatasetalteracao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetalteracao.Name := 'Rt_Ibs_Cbs_CstDatasetalteracao';
    Rt_Ibs_Cbs_CstDatasetalteracao.FieldName := 'alteracao';
    Rt_Ibs_Cbs_CstDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Ibs_Cbs_CstDatasetexclusao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetexclusao.Name := 'Rt_Ibs_Cbs_CstDatasetexclusao';
    Rt_Ibs_Cbs_CstDatasetexclusao.FieldName := 'exclusao';
    Rt_Ibs_Cbs_CstDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Rt_Ibs_Cbs_CstDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 168;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 192;
    tmrConsulta.Top := 136;
    excelImport.SetParentComponent(Self);
    excelImport.Name := 'excelImport';
    SetEvent(excelImport, Self, 'OnWorkbookLoaded', 'excelImportWorkbookLoaded');
    SetEvent(excelImport, Self, 'OnSheetLoaded', 'excelImportSheetLoaded');
    excelImport.Left := 120;
    excelImport.Top := 440;
    cdsIbsCbsCst.SetParentComponent(Self);
    cdsIbsCbsCst.Name := 'cdsIbsCbsCst';
    cdsIbsCbsCst.AfterOpen := cdsIbsCbsCstAfterOpen;
    SetEvent(cdsIbsCbsCst, Self, 'OnFilterRecord', 'cdsIbsCbsCstFilterRecord');
    cdsIbsCbsCst.EntitySetName := 'Rt_Ibs_Cbs_Cst';
    cdsIbsCbsCst.Connection := DMConnection.ApiConnection;
    cdsIbsCbsCst.QueryTop := 200;
    cdsIbsCbsCst.Left := 480;
    cdsIbsCbsCst.Top := 112;
    cdsIbsCbsCstid.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstid.Name := 'cdsIbsCbsCstid';
    cdsIbsCbsCstid.FieldName := 'id';
    cdsIbsCbsCstcst.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstcst.Name := 'cdsIbsCbsCstcst';
    cdsIbsCbsCstcst.FieldName := 'cst';
    cdsIbsCbsCstcst.Required := True;
    cdsIbsCbsCstcst.Size := 255;
    cdsIbsCbsCstdescricao.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstdescricao.Name := 'cdsIbsCbsCstdescricao';
    cdsIbsCbsCstdescricao.FieldName := 'descricao';
    cdsIbsCbsCstdescricao.Required := True;
    cdsIbsCbsCstdescricao.Size := 255;
    cdsIbsCbsCstexcluido.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstexcluido.Name := 'cdsIbsCbsCstexcluido';
    cdsIbsCbsCstexcluido.FieldName := 'excluido';
    cdsIbsCbsCstinclusao.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstinclusao.Name := 'cdsIbsCbsCstinclusao';
    cdsIbsCbsCstinclusao.FieldName := 'inclusao';
    cdsIbsCbsCstalteracao.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstalteracao.Name := 'cdsIbsCbsCstalteracao';
    cdsIbsCbsCstalteracao.FieldName := 'alteracao';
    cdsIbsCbsCstexclusao.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstexclusao.Name := 'cdsIbsCbsCstexclusao';
    cdsIbsCbsCstexclusao.FieldName := 'exclusao';
    cdsIbsCbsCstprocessado.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstprocessado.Name := 'cdsIbsCbsCstprocessado';
    cdsIbsCbsCstprocessado.FieldKind := fkCalculated;
    cdsIbsCbsCstprocessado.FieldName := 'processado';
    cdsIbsCbsCstprocessado.Calculated := True;
    cdsIbsCbsCstind_gIBSCBS.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gIBSCBS.Name := 'cdsIbsCbsCstind_gIBSCBS';
    cdsIbsCbsCstind_gIBSCBS.FieldName := 'ind_gIBSCBS';
    cdsIbsCbsCstind_gIBSCBS.Size := 255;
    cdsIbsCbsCstind_gIBSCBSMono.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gIBSCBSMono.Name := 'cdsIbsCbsCstind_gIBSCBSMono';
    cdsIbsCbsCstind_gIBSCBSMono.FieldName := 'ind_gIBSCBSMono';
    cdsIbsCbsCstind_gIBSCBSMono.Size := 255;
    cdsIbsCbsCstind_gRed.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gRed.Name := 'cdsIbsCbsCstind_gRed';
    cdsIbsCbsCstind_gRed.FieldName := 'ind_gRed';
    cdsIbsCbsCstind_gRed.Size := 255;
    cdsIbsCbsCstind_gDif.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gDif.Name := 'cdsIbsCbsCstind_gDif';
    cdsIbsCbsCstind_gDif.FieldName := 'ind_gDif';
    cdsIbsCbsCstind_gDif.Size := 255;
    cdsIbsCbsCstind_gTransfCred.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gTransfCred.Name := 'cdsIbsCbsCstind_gTransfCred';
    cdsIbsCbsCstind_gTransfCred.FieldName := 'ind_gTransfCred';
    cdsIbsCbsCstind_gTransfCred.Size := 255;
    cdsIbsCbsCstind_gCredPresIBSZFM.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gCredPresIBSZFM.Name := 'cdsIbsCbsCstind_gCredPresIBSZFM';
    cdsIbsCbsCstind_gCredPresIBSZFM.FieldName := 'ind_gCredPresIBSZFM';
    cdsIbsCbsCstind_gAjusteCompet.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_gAjusteCompet.Name := 'cdsIbsCbsCstind_gAjusteCompet';
    cdsIbsCbsCstind_gAjusteCompet.FieldName := 'ind_gAjusteCompet';
    cdsIbsCbsCstexcluido_planilha.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstexcluido_planilha.Name := 'cdsIbsCbsCstexcluido_planilha';
    cdsIbsCbsCstexcluido_planilha.FieldName := 'excluido_planilha';
    cdsIbsCbsCstind_RedutorBC.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstind_RedutorBC.Name := 'cdsIbsCbsCstind_RedutorBC';
    cdsIbsCbsCstind_RedutorBC.FieldName := 'ind_RedutorBC';
    cdsClassTrib.SetParentComponent(Self);
    cdsClassTrib.Name := 'cdsClassTrib';
    cdsClassTrib.AfterOpen := cdsClassTribAfterOpen;
    SetEvent(cdsClassTrib, Self, 'OnFilterRecord', 'cdsClassTribFilterRecord');
    cdsClassTrib.EntitySetName := 'Rt_Ibs_Cbs_Class_Tributaria';
    cdsClassTrib.Connection := DMConnection.ApiConnection;
    cdsClassTrib.QueryString := '$expand=rt_cst_ibs_cbs';
    cdsClassTrib.QueryTop := 1000;
    cdsClassTrib.Left := 520;
    cdsClassTrib.Top := 352;
    cdsClassTribid.SetParentComponent(cdsClassTrib);
    cdsClassTribid.Name := 'cdsClassTribid';
    cdsClassTribid.FieldName := 'id';
    cdsClassTribid.Required := True;
    cdsClassTribrt_ibs_cbs_cst_id.SetParentComponent(cdsClassTrib);
    cdsClassTribrt_ibs_cbs_cst_id.Name := 'cdsClassTribrt_ibs_cbs_cst_id';
    cdsClassTribrt_ibs_cbs_cst_id.FieldName := 'rt_ibs_cbs_cst_id';
    cdsClassTribrt_ibs_cbs_cst_id.Required := True;
    cdsClassTribcclasstrib.SetParentComponent(cdsClassTrib);
    cdsClassTribcclasstrib.Name := 'cdsClassTribcclasstrib';
    cdsClassTribcclasstrib.FieldName := 'cclasstrib';
    cdsClassTribcclasstrib.Required := True;
    cdsClassTribcclasstrib.Size := 255;
    cdsClassTribdescricao.SetParentComponent(cdsClassTrib);
    cdsClassTribdescricao.Name := 'cdsClassTribdescricao';
    cdsClassTribdescricao.FieldName := 'descricao';
    cdsClassTribdescricao.Required := True;
    cdsClassTribdescricao.Size := 255;
    cdsClassTriblei_complementar.SetParentComponent(cdsClassTrib);
    cdsClassTriblei_complementar.Name := 'cdsClassTriblei_complementar';
    cdsClassTriblei_complementar.FieldName := 'lei_complementar';
    cdsClassTriblei_complementar.Size := 255;
    cdsClassTriblei_complementar_redacao.SetParentComponent(cdsClassTrib);
    cdsClassTriblei_complementar_redacao.Name := 'cdsClassTriblei_complementar_redacao';
    cdsClassTriblei_complementar_redacao.FieldName := 'lei_complementar_redacao';
    cdsClassTriblei_complementar_redacao.Size := 255;
    cdsClassTribdata_inicio.SetParentComponent(cdsClassTrib);
    cdsClassTribdata_inicio.Name := 'cdsClassTribdata_inicio';
    cdsClassTribdata_inicio.FieldName := 'data_inicio';
    cdsClassTribdata_inicio.DisplayFormat := 'dd/mm/yyyy';
    cdsClassTribdata_fim.SetParentComponent(cdsClassTrib);
    cdsClassTribdata_fim.Name := 'cdsClassTribdata_fim';
    cdsClassTribdata_fim.FieldName := 'data_fim';
    cdsClassTribdata_fim.DisplayFormat := 'dd/mm/yyyy';
    cdsClassTribexcluido.SetParentComponent(cdsClassTrib);
    cdsClassTribexcluido.Name := 'cdsClassTribexcluido';
    cdsClassTribexcluido.FieldName := 'excluido';
    cdsClassTribrt_cst_ibs_cbscst.SetParentComponent(cdsClassTrib);
    cdsClassTribrt_cst_ibs_cbscst.Name := 'cdsClassTribrt_cst_ibs_cbscst';
    cdsClassTribrt_cst_ibs_cbscst.FieldKind := fkCalculated;
    cdsClassTribrt_cst_ibs_cbscst.FieldName := 'rt_cst_ibs_cbs.cst';
    cdsClassTribrt_cst_ibs_cbscst.Calculated := True;
    cdsClassTribprocessado.SetParentComponent(cdsClassTrib);
    cdsClassTribprocessado.Name := 'cdsClassTribprocessado';
    cdsClassTribprocessado.FieldKind := fkCalculated;
    cdsClassTribprocessado.FieldName := 'processado';
    cdsClassTribprocessado.Calculated := True;
    cdsClassTribrt_cst_ibs_cbs.SetParentComponent(cdsClassTrib);
    cdsClassTribrt_cst_ibs_cbs.Name := 'cdsClassTribrt_cst_ibs_cbs';
    cdsClassTribrt_cst_ibs_cbs.FieldName := 'rt_cst_ibs_cbs';
    cdsClassTribrt_cst_ibs_cbsexcluido.SetParentComponent(cdsClassTrib);
    cdsClassTribrt_cst_ibs_cbsexcluido.Name := 'cdsClassTribrt_cst_ibs_cbsexcluido';
    cdsClassTribrt_cst_ibs_cbsexcluido.FieldName := 'rt_cst_ibs_cbs.excluido';
    cdsClassTribnome_cClassTrib.SetParentComponent(cdsClassTrib);
    cdsClassTribnome_cClassTrib.Name := 'cdsClassTribnome_cClassTrib';
    cdsClassTribnome_cClassTrib.FieldName := 'nome_cClassTrib';
    cdsClassTribnome_cClassTrib.Size := 255;
    cdsClassTribtipo_aliquota.SetParentComponent(cdsClassTrib);
    cdsClassTribtipo_aliquota.Name := 'cdsClassTribtipo_aliquota';
    cdsClassTribtipo_aliquota.FieldName := 'tipo_aliquota';
    cdsClassTribtipo_aliquota.Size := 255;
    cdsClassTribpRedIBS.SetParentComponent(cdsClassTrib);
    cdsClassTribpRedIBS.Name := 'cdsClassTribpRedIBS';
    cdsClassTribpRedIBS.FieldName := 'pRedIBS';
    cdsClassTribpRedIBS.Size := 255;
    cdsClassTribpRedCBS.SetParentComponent(cdsClassTrib);
    cdsClassTribpRedCBS.Name := 'cdsClassTribpRedCBS';
    cdsClassTribpRedCBS.FieldName := 'pRedCBS';
    cdsClassTribpRedCBS.Size := 255;
    cdsClassTribind_gTribRegular.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gTribRegular.Name := 'cdsClassTribind_gTribRegular';
    cdsClassTribind_gTribRegular.FieldName := 'ind_gTribRegular';
    cdsClassTribind_gTribRegular.Size := 255;
    cdsClassTribdata_atualizacao.SetParentComponent(cdsClassTrib);
    cdsClassTribdata_atualizacao.Name := 'cdsClassTribdata_atualizacao';
    cdsClassTribdata_atualizacao.FieldName := 'data_atualizacao';
    cdsClassTribindNFe.SetParentComponent(cdsClassTrib);
    cdsClassTribindNFe.Name := 'cdsClassTribindNFe';
    cdsClassTribindNFe.FieldName := 'indNFe';
    cdsClassTribindNFCe.SetParentComponent(cdsClassTrib);
    cdsClassTribindNFCe.Name := 'cdsClassTribindNFCe';
    cdsClassTribindNFCe.FieldName := 'indNFCe';
    cdsClassTribindNFSe.SetParentComponent(cdsClassTrib);
    cdsClassTribindNFSe.Name := 'cdsClassTribindNFSe';
    cdsClassTribindNFSe.FieldName := 'indNFSe';
    cdsClassTribind_gEstornoCred.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gEstornoCred.Name := 'cdsClassTribind_gEstornoCred';
    cdsClassTribind_gEstornoCred.FieldName := 'ind_gEstornoCred';
    cdsClassTribind_gCredPresOper.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gCredPresOper.Name := 'cdsClassTribind_gCredPresOper';
    cdsClassTribind_gCredPresOper.FieldName := 'ind_gCredPresOper';
    cdsClassTribind_gMonoPadrao.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gMonoPadrao.Name := 'cdsClassTribind_gMonoPadrao';
    cdsClassTribind_gMonoPadrao.FieldName := 'ind_gMonoPadrao';
    cdsClassTribind_gMonoReten.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gMonoReten.Name := 'cdsClassTribind_gMonoReten';
    cdsClassTribind_gMonoReten.FieldName := 'ind_gMonoReten';
    cdsClassTribind_gMonoRet.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gMonoRet.Name := 'cdsClassTribind_gMonoRet';
    cdsClassTribind_gMonoRet.FieldName := 'ind_gMonoRet';
    cdsClassTribexcluido_planilha.SetParentComponent(cdsClassTrib);
    cdsClassTribexcluido_planilha.Name := 'cdsClassTribexcluido_planilha';
    cdsClassTribexcluido_planilha.FieldName := 'excluido_planilha';
    cdsClassTribind_gpBioDiferenca.SetParentComponent(cdsClassTrib);
    cdsClassTribind_gpBioDiferenca.Name := 'cdsClassTribind_gpBioDiferenca';
    cdsClassTribind_gpBioDiferenca.FieldName := 'ind_gpBioDiferenca';
    cdsClassTribtpRBSN.SetParentComponent(cdsClassTrib);
    cdsClassTribtpRBSN.Name := 'cdsClassTribtpRBSN';
    cdsClassTribtpRBSN.FieldName := 'tpRBSN';
    cdsClassTribtpDoacao.SetParentComponent(cdsClassTrib);
    cdsClassTribtpDoacao.Name := 'cdsClassTribtpDoacao';
    cdsClassTribtpDoacao.FieldName := 'tpDoacao';
    dtsIbsCbsCst.SetParentComponent(Self);
    dtsIbsCbsCst.Name := 'dtsIbsCbsCst';
    dtsIbsCbsCst.DataSet := cdsIbsCbsCst;
    dtsIbsCbsCst.Left := 576;
    dtsIbsCbsCst.Top := 128;
    XDataClientImport.SetParentComponent(Self);
    XDataClientImport.Name := 'XDataClientImport';
    XDataClientImport.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientImport, Self, 'OnLoad', 'XDataClientImportLoad');
    SetEvent(XDataClientImport, Self, 'OnError', 'XDataClientImportError');
    XDataClientImport.Left := 216;
    XDataClientImport.Top := 457;
    dtsClassTrib.SetParentComponent(Self);
    dtsClassTrib.Name := 'dtsClassTrib';
    dtsClassTrib.DataSet := cdsClassTrib;
    dtsClassTrib.Left := 600;
    dtsClassTrib.Top := 304;
    tmrProcessarPlanilhas.SetParentComponent(Self);
    tmrProcessarPlanilhas.Name := 'tmrProcessarPlanilhas';
    tmrProcessarPlanilhas.Enabled := False;
    SetEvent(tmrProcessarPlanilhas, Self, 'OnTimer', 'tmrProcessarPlanilhasTimer');
    tmrProcessarPlanilhas.Left := 312;
    tmrProcessarPlanilhas.Top := 376;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    lblErro.AfterLoadDFMValues;
    lblOrdemColunas.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    cbbTipoImportacao.AfterLoadDFMValues;
    wfpImport.AfterLoadDFMValues;
    btnImportarTabela.AfterLoadDFMValues;
    btnUpload.AfterLoadDFMValues;
    pnlEspacoTabelaRt_Ibs_Cbs_Cst.AfterLoadDFMValues;
    pnlEspacoImportacao.AfterLoadDFMValues;
    pnlEspacoImportacaoRt_Ibs_Cbs_Cst.AfterLoadDFMValues;
    tblImportacaoIbsCbsCst.AfterLoadDFMValues;
    pnlEspacoImportacaoClassTrib.AfterLoadDFMValues;
    tblImportacaoClassTrib.AfterLoadDFMValues;
    btnConfirmarIbsCbsCst.AfterLoadDFMValues;
    btnConfirmarClassTrib.AfterLoadDFMValues;
    cbbFiltroClassTrib.AfterLoadDFMValues;
    cbbFiltroIbsCbsCst.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDataset.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetid.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetcst.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetdescricao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetexcluido.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetinclusao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetalteracao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    excelImport.AfterLoadDFMValues;
    cdsIbsCbsCst.AfterLoadDFMValues;
    cdsIbsCbsCstid.AfterLoadDFMValues;
    cdsIbsCbsCstcst.AfterLoadDFMValues;
    cdsIbsCbsCstdescricao.AfterLoadDFMValues;
    cdsIbsCbsCstexcluido.AfterLoadDFMValues;
    cdsIbsCbsCstinclusao.AfterLoadDFMValues;
    cdsIbsCbsCstalteracao.AfterLoadDFMValues;
    cdsIbsCbsCstexclusao.AfterLoadDFMValues;
    cdsIbsCbsCstprocessado.AfterLoadDFMValues;
    cdsIbsCbsCstind_gIBSCBS.AfterLoadDFMValues;
    cdsIbsCbsCstind_gIBSCBSMono.AfterLoadDFMValues;
    cdsIbsCbsCstind_gRed.AfterLoadDFMValues;
    cdsIbsCbsCstind_gDif.AfterLoadDFMValues;
    cdsIbsCbsCstind_gTransfCred.AfterLoadDFMValues;
    cdsIbsCbsCstind_gCredPresIBSZFM.AfterLoadDFMValues;
    cdsIbsCbsCstind_gAjusteCompet.AfterLoadDFMValues;
    cdsIbsCbsCstexcluido_planilha.AfterLoadDFMValues;
    cdsIbsCbsCstind_RedutorBC.AfterLoadDFMValues;
    cdsClassTrib.AfterLoadDFMValues;
    cdsClassTribid.AfterLoadDFMValues;
    cdsClassTribrt_ibs_cbs_cst_id.AfterLoadDFMValues;
    cdsClassTribcclasstrib.AfterLoadDFMValues;
    cdsClassTribdescricao.AfterLoadDFMValues;
    cdsClassTriblei_complementar.AfterLoadDFMValues;
    cdsClassTriblei_complementar_redacao.AfterLoadDFMValues;
    cdsClassTribdata_inicio.AfterLoadDFMValues;
    cdsClassTribdata_fim.AfterLoadDFMValues;
    cdsClassTribexcluido.AfterLoadDFMValues;
    cdsClassTribrt_cst_ibs_cbscst.AfterLoadDFMValues;
    cdsClassTribprocessado.AfterLoadDFMValues;
    cdsClassTribrt_cst_ibs_cbs.AfterLoadDFMValues;
    cdsClassTribrt_cst_ibs_cbsexcluido.AfterLoadDFMValues;
    cdsClassTribnome_cClassTrib.AfterLoadDFMValues;
    cdsClassTribtipo_aliquota.AfterLoadDFMValues;
    cdsClassTribpRedIBS.AfterLoadDFMValues;
    cdsClassTribpRedCBS.AfterLoadDFMValues;
    cdsClassTribind_gTribRegular.AfterLoadDFMValues;
    cdsClassTribdata_atualizacao.AfterLoadDFMValues;
    cdsClassTribindNFe.AfterLoadDFMValues;
    cdsClassTribindNFCe.AfterLoadDFMValues;
    cdsClassTribindNFSe.AfterLoadDFMValues;
    cdsClassTribind_gEstornoCred.AfterLoadDFMValues;
    cdsClassTribind_gCredPresOper.AfterLoadDFMValues;
    cdsClassTribind_gMonoPadrao.AfterLoadDFMValues;
    cdsClassTribind_gMonoReten.AfterLoadDFMValues;
    cdsClassTribind_gMonoRet.AfterLoadDFMValues;
    cdsClassTribexcluido_planilha.AfterLoadDFMValues;
    cdsClassTribind_gpBioDiferenca.AfterLoadDFMValues;
    cdsClassTribtpRBSN.AfterLoadDFMValues;
    cdsClassTribtpDoacao.AfterLoadDFMValues;
    dtsIbsCbsCst.AfterLoadDFMValues;
    XDataClientImport.AfterLoadDFMValues;
    dtsClassTrib.AfterLoadDFMValues;
    tmrProcessarPlanilhas.AfterLoadDFMValues;
  end;
end;

end.

